import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map, catchError, filter, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { User, UserRole, RoleEntities } from '../models/User';
import { EntityTailConfig } from '../models/EntityTailConfig';
import { YearRangeTail } from '../models/YearRangeTail';
import { LegalEntityAndCounterPartySummaryResponse } from '../models/LegalEntityAndCounterPartySummaryResponse';
import { DerivativeExposureResponse } from '../models/DerivativeExposureResponse';
import { CacheService } from './cache.service';
import { AampQuota } from '../models/AampQuota';
import { ServiceRequest } from '../models/ServiceRequest';
import { Store } from '../../store';
import { QueryConfig } from '../models/QueryConfig';
import { TradeSimulation } from '../models/TradeSimulation';
import { FxRate } from "../models/FxRate";
import { SimulationNotification, SimulationNotificationUpdate } from '../models/SimulationNotification';
import { UpdateProjectionsRequest } from '../models/updateprojectionsRequest';
import { isNil } from 'lodash-es';
import { LowestCcrsAndShockedCcrs } from '../models/LowestCcrsAndShockedCcr';
import {Router} from "@angular/router";
import { environment } from 'src/environments/environment';

const BASE_URL = environment.apiUrl + environment.apiRoot;

@Injectable()
export class DataService {

    constructor(private http: HttpClient, private cacheService: CacheService, private store: Store,private _router: Router) {
    }

    getRefreshCache(): Observable<any>{
        const requestUrl = BASE_URL + 'download/refreshCache';
        return this.getCacheDataOrHttpGet<any>(requestUrl);
   }

    getUserProfile(): Observable<any> {
        //const requestUrl = BASE_URL + 'user/' + uid;
        const requestUrl = BASE_URL + 'user';
        //return Observable.of(this.getFakeUserData());
       return this.getCacheDataOrHttpGet<User>(requestUrl);
    }

    getUserRoles(): Observable<UserRole> {
        const  requestUrl = BASE_URL + 'user'+ '/roles';
        return this.getCacheDataOrHttpGet<UserRole>(requestUrl);
    }

    getRawUser(uid: string): Observable<any> {
        //const requestUrl = BASE_URL + 'user/raw/' + uid;
        const requestUrl = BASE_URL + 'user/raw';
        //return Observable.of(this.getFakeUserData());
        return this.getCacheDataOrHttpGet<User>(requestUrl);
    }

    getEntitiesByRoles(): Observable<any> {
        const requestUrl = BASE_URL + 'user/getEntitiesByRoles';
        //return Observable.of(this.getFakeEntitiesRolesData());
        return this.getCacheDataOrHttpGet<RoleEntities>(requestUrl);
    }

    getAllUserRoles(): Observable<any> {
        const requestUrl = BASE_URL + 'user/userslist';
        return this.http.get<UserRole>(requestUrl)
        //return this.getCacheDataOrHttpGet<UserRole>(requestUrl)
        //return Observable.of(this.getFakeUserRole());
    }

    getFxRates(): Observable<any> {
        const requestUrl = BASE_URL + 'fxrates';
       //return Observable.of(this.getFakeFxRateData());
       return this.getCacheDataOrHttpGet<FxRate>(requestUrl);
    }

    getCounterPartiesByEntityName(id: string): Observable<string[]> {
        return this.getCacheDataOrHttpGet<string[]>(BASE_URL + 'getCounterPartiesByEntityName' + id);
    }

    getLowestWccrList(groupLevelTail: YearRangeTail[], countryLevelTails: EntityTailConfig[], shockMtmValue: string,
        rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash
        };

       return this.getCacheDataOrHttpPost<any>(BASE_URL + 'overview/getLowestWccrList', wccrServiceRequest);
       // return Observable.of(this.getFakeLowestWccrListData());

    }

    getTenLowestWccrsWithShock(groupLevelTail: YearRangeTail[], countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean): Observable<any> {

        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash
        };
        //return Observable.of(this.getFakeTenLowestWccrWithShockData());
         return this.getCacheDataOrHttpPost<LowestCcrsAndShockedCcrs[]>(BASE_URL + 'overview/getTenLowestWccrsWithShock'
        , wccrServiceRequest);
    }

    getWccrSummary(groupLevelTail: YearRangeTail[], countryLevelTails: EntityTailConfig[], shockMtmValue: string, rolloverToCash: boolean)
        : Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash
        };
       return this.getCacheDataOrHttpPost<LegalEntityAndCounterPartySummaryResponse>
        (BASE_URL + 'overview/getWccrSummary', wccrServiceRequest);
      //return Observable.of(this.getFakeWccrSummaryData());
    }

    getDerivativeExposureSummary(groupLevelTail: YearRangeTail[], countryLevelTails: EntityTailConfig[], shockMtmValue: string,
        showLegalEntities: boolean, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash
        };
      //return Observable.of(this.getFakeDerivativeExposure());

          return this.getCacheDataOrHttpPost<DerivativeExposureResponse>
          (BASE_URL + 'overview/getDerivativeExposure?showLegalEntities=' + showLegalEntities, wccrServiceRequest);

     }

     getDerivativeExposureSummaryHide(groupLevelTail: YearRangeTail[], countryLevelTails: EntityTailConfig[], shockMtmValue: string,
        showLegalEntities: boolean, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash
        };

        //return Observable.of(this.getFakeDerivativeExposureHide());

        return this.getCacheDataOrHttpPost<DerivativeExposureResponse>
        (BASE_URL + 'overview/getDerivativeExposure?showLegalEntities=' + showLegalEntities, wccrServiceRequest);

     }

    getAampQuotaData(entity: string): Observable<any> {
        return this.getCacheDataOrHttpGet(BASE_URL + 'aampQuotaData?entity=' + entity);
         //return Observable.of(this.getFakeAampQuotasData());
    }

    getLastPricingExecDate(): Observable<any> {
        return this.getCacheTextOrHttpGet(BASE_URL + 'lastPricingExecDate');
         //return Observable.of(this.getFakeLastPricingExecDate());
    }

    getAampProductInfo(entity: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType,
            entity: entity
        };
        return this.getCacheDataOrHttpPost<any>(BASE_URL + 'getAampProductInfo', wccrServiceRequest);
         //return Observable.of(this.getFakeAampProductData());
    }
    getAampProductInfoSimu(entity: string, model: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType
        };
        return this.http.post<any>(BASE_URL + `getAampProductInfoSimu/${entity}/${model}`, wccrServiceRequest);
    }

    getAampUsedQuotaDataSimu(entity: string, model: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[], shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType
        };
        return this.http.post<any>(BASE_URL + `getUsedQuotaSimu/${entity}/${model}`, wccrServiceRequest);
    }

    getAampUsedQuotaData(entity: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[], shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType,
            entity: entity
        };

        return this.getCacheDataOrHttpPost<any>(BASE_URL + `entityDerivativeHoldings`, wccrServiceRequest);
        //return Observable.of(this.getFakeAampQuotasData());
         //return Observable.of(this.getFakeDerivativeHoldingsData());
    }
    getEntityDerivativeHoldingsSimu(entity: string, modelID: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[], shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType
        };
        return this.getCacheDataOrHttpPost<any>(BASE_URL + `entityDerivativeHoldingsSimu/${entity}/${modelID}`, wccrServiceRequest);
    }


    getEntityCounterPartyCcrAndEce(entity: string, counterParty: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean, modelId): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            modelId: modelId,
            entity: entity,
            counterParty: counterParty
        };
        counterParty = counterParty && counterParty.length > 0 ? '/' + counterParty : '';
         //return Observable.of(this.getFakeCCrAndEceData());
        return this.getCacheDataOrHttpPost<any>(BASE_URL + `ccrAndEce`, wccrServiceRequest);
    }

    getEntityCounterPartyCcrAndEceSimu(entity: string, counterParty: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean, modelId): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            modelId: modelId
        };
        counterParty = counterParty && counterParty.length > 0 ? '/' + counterParty : '';
        //return Observable.of(this.getFakeCCrAndEceData());
        return this.http.post<any>(BASE_URL + `ccrAndEceSimu/${entity}${counterParty}/${modelId}`, wccrServiceRequest);
    }


    getLastMonthEntityCounterPartyCcrAndEce(entity: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            entity:entity
        };
        return this.getCacheDataOrHttpPost<any>(BASE_URL + `lastMonthCcrAndEce`, wccrServiceRequest);
         //return Observable.of(this.getFakeLastMonthCcrAndEceData());
    }

    getCounterPartyDerivativeAndCollateral(entity: string, counterParty: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            entity:entity,
            counterParty: counterParty
        };
        return this.getCacheDataOrHttpPost<any>(BASE_URL + `derivativeVsCollateral`, wccrServiceRequest);
    }

    getWccrPeriods(entity: string, counterParty: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[],
        shockMtmValue: string, rolloverToCash: boolean): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash
        };
        return this.getCacheDataOrHttpPost<any>
            (BASE_URL + `wccrPeriods/${entity}/${counterParty}`, wccrServiceRequest);
    }

    getEntityInstruments(entity: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[], shockMtmValue: string, rolloverToCash: boolean,
        productName?: string): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType,
            instrumentGridProductName: productName ? productName : null,
            entity: entity
        };
        return this.getCacheDataOrHttpPost<any>(BASE_URL + `instruments/ALL`, wccrServiceRequest);
       // return Observable.of(this.getFakeIntrumentsData());
    }

    getEntityInstrumentsSimu(entity: string, modelID: string, from: number, to: number, instrumentType: string, groupLevelTail: YearRangeTail[],
        countryLevelTails: EntityTailConfig[], shockMtmValue: string, rolloverToCash: boolean,
        productName?: string): Observable<any> {
        const wccrServiceRequest = {
            groupLevelTail: groupLevelTail,
            countryLevelTails: countryLevelTails,
            associatedLegalEntities: null,
            shockMtmValue: shockMtmValue,
            rolloverToCash: rolloverToCash,
            instrumentGridFrom: from,
            instrumentGridTo: to,
            instrumentGridInstrumentType: instrumentType,
            instrumentGridProductName: productName ? productName : null
        };
         return this.http.post<any>(BASE_URL + `instrumentsSimu/${entity}/${modelID}`, wccrServiceRequest);
       //return Observable.of(this.getFakeIntrumentsData());
    }

    getEntityCounterPartyInstruments(wccrServiceRequest: ServiceRequest): Observable<any> {
        return this.getCacheDataOrHttpPost<any>
            (BASE_URL + `instruments`, wccrServiceRequest);
    }

    updateSettings(queryConfig: QueryConfig): Observable<any> {
        return this.http.post<any>(BASE_URL + `settings/update`, queryConfig);
    }

    updateUserSettings(updateList: UserRole[]): Observable<any> {
        const userDataUpdates = {
            updateList: updateList
        };
        return this.http.post<any>(BASE_URL + `user/update`, userDataUpdates);
    }

    deleteUser(user: UserRole): Observable<any> {
        const userData = {
            uid: user.uid,
            role: user.role,
            firstName: user.firstName,
            lastName: user.lastName,
            rowKey: user.rowKey
        };
        return this.http.post<boolean>(BASE_URL + `user/delete`, userData);
    }

    updateAampMaxQuota(entityName: string, aampQuotas: AampQuota[]): Observable<boolean> {
        const updateRequest = {
            aampQuotas: aampQuotas,
            legalEntityName: entityName
        };

        return this.http.post<boolean>(BASE_URL + 'aampQuota/update', updateRequest);
    }

    createTradeSimulation(tradeSimulation: TradeSimulation): Observable<boolean> {
        return this.http.post<boolean>(BASE_URL + 'trade/create', tradeSimulation);
    }

    deleteTradeSimulation(tradeSimulation: TradeSimulation): Observable<boolean> {
        return this.http.post<boolean>(BASE_URL + 'trade/delete', tradeSimulation);
    }

    editTradeSimulation(tradeSimulation: TradeSimulation): Observable<boolean> {
        return this.http.post<boolean>(BASE_URL + 'trade/edit', tradeSimulation);
    }

    getEntityTrades(entity: string): Observable<any> {
        return this.http.get<any>(BASE_URL + 'trades?entity=' + entity);
        // return Observable.of(this.getFakeTradesData());
    }

    getTradeInformation(modelId: string): Observable<any> {
        return this.http.get<any>(BASE_URL + 'trade/' + modelId);
    }

    downloadAllScenariosFile() {
        console.log('downloadAllScenariosFile...');
        let options: any = {};
        options.responseType = 'blob';
        return this.http.get(BASE_URL + 'download/allScenarios', options);
    }

    downloadLogsFile() {
        console.log('downloadLogsFile...');
        let options: any = {};
        options.responseType = 'blob';
        return this.http.get(BASE_URL + 'download/logs', options);
    }

    downloadInvoicesFile(req: any) {
        console.log('downloadInvoiceFile...');
        let options: any = {};
        options.responseType = 'blob';
        return this.http.post(BASE_URL + 'download/invoices', req, options);
    }

    getNormalApiToken(): Observable<any> {
         return this.http.get<any>(environment.apiUrl + 'api/token');
    }

    getCacheDataOrHttpGet<T>(url: string): Observable<T> {
        const cachedValue = this.cacheService.getByHttpRequest<T>(url, null);
        if (cachedValue) {
            return of(cachedValue);
        }
        return this.http.get<T>(url).pipe(
            map(x => {
                this.cacheService.setByHttpRequest(url, null, x);
                return x;
            })
        );
    }
    getCacheTextOrHttpGet(url: string): Observable<string> {
        const cachedValue = this.cacheService.getByHttpRequest<string>(url, null);
        if (cachedValue) {
            return of(cachedValue);
        }
        const headers = new HttpHeaders({'responseType':"text"});
        const options = {headers:headers};
        return this.http.get<string>(url, options).pipe(
            map(x => {
                this.cacheService.setByHttpRequest(url, null, x);
                return x;
            })
        );
    }

    getCacheDataOrHttpPost<T>(url: string, params: any): Observable<T> {
        const cachedValue = this.cacheService.getByHttpRequest<T>(url, params);
        if (cachedValue) {
            return of(cachedValue);
        }
        return this.http.post<T>(url, params).pipe(
            map(x => {
                this.cacheService.setByHttpRequest(url, params, x);
                return x;
            })
        );
    }

    clearCacheData() {
        this.cacheService.clearCache();
    }

    private getFakeUserRole() {
        return [{
            "uid": "d51759",
            "role": "ADMIN",
            "firstName": "testfirstname",
            "lastName": "testlastname",
            "rowKey": "rowkey1",
        },
        {
            "uid": "d51759",
            "role": "SUPERADMIN",
            "firstName": "testfirstname",
            "lastName": "testlastname",
            "rowKey": "rowkey2",
        },
        {
            "uid": "d51759",
            "role": "USER",
            "firstName": "testfirstname",
            "lastName": "testlastname",
            "rowKey": "rowkey3",
        },
        {
            "uid": "d51759",
            "role": "AIA GCC",
            "firstName": "testfirstname",
            "lastName": "testlastname",
            "rowKey": "rowkey4",
        },
        {
            "uid": "d54233",
            "role": "ADMIN",
            "firstName": "bel",
            "lastName": "fru",
            "rowKey": "rowkey5",
        },
        {
            "uid": "d54233",
            "role": "USER",
            "firstName": "bel",
            "lastName": "fru",
            "rowKey": "rowkey6",
        },
        {
            "uid": "d54233",
            "role": "AIA GCC",
            "firstName": "bel",
            "lastName": "fru",
            "rowKey": "rowkey ",
        },
        {
            "uid": "d54233",
            "role": "AIAI - HO",
            "firstName": "bel",
            "lastName": "fru",
            "rowKey": "rowkey8",
        }
        ];
    }

    private getFakeLastPricingExecDate() {
        return "2022-03-31";
    }

    private getFakeEntitiesRolesData() {
        return [
            {
                roleID: 'USER',
                roleName: 'USER role',
                legalEntities: [{
                    "entityId": null,
                    "dataName": "USER AIA Australia",
                    "name": "Australia",
                    "code": "AUS",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "USER AIA CO LTD - SF",
                    "name": "SF",
                    "code": "SF",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "Standard Chartered",
                        "HSBC",
                        "BNP Paribas"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "USER AIAI - HO",
                    "name": "HO",
                    "code": "HO",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA Thailand",
                    "name": "Thailand",
                    "code": "THAI",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIAI - POP",
                    "name": "POP",
                    "code": "POP",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA PARIS",
                    "name": "Paris",
                    "code": "PAR",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                }]
            },
            {
                roleID: 'ADMIN',
                roleName: 'ADMIN role',
                legalEntities: [{
                    "entityId": null,
                    "dataName": "AIA Australia ADMIN",
                    "name": "Australia",
                    "code": "AUS",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA CO LTD - SF",
                    "name": "SF",
                    "code": "SF",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "Standard Chartered",
                        "HSBC",
                        "BNP Paribas"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIAI - HO",
                    "name": "HO",
                    "code": "HO",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "ADMIN AIA Thailand",
                    "name": "Thailand",
                    "code": "THAI",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIAI - POP",
                    "name": "POP",
                    "code": "POP",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA PARIS",
                    "name": "Paris",
                    "code": "PAR",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                }]
            },
            {
                roleID: 'AIA GCC',
                roleName: 'AIA GCC',
                legalEntities: [{
                    "entityId": null,
                    "dataName": "AIA Australia GCC",
                    "name": "Australia",
                    "code": "AUS",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA CO LTD - SF",
                    "name": "SF",
                    "code": "SF",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "Standard Chartered",
                        "HSBC",
                        "BNP Paribas"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIAI - HO",
                    "name": "HO",
                    "code": "HO",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA Thailand",
                    "name": "Thailand",
                    "code": "THAI",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIAI - POP",
                    "name": "POP",
                    "code": "POP",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                },
                {
                    "entityId": null,
                    "dataName": "AIA PARIS",
                    "name": "Paris",
                    "code": "PAR",
                    "ccrOrExpo": 23,
                    "counterParties": [
                        "ALL"
                    ]
                }]
            },
            {
                roleID: 'AIA PH',
                roleName: 'AIA PH role',
                legalEntities: []
            },
            {
                roleID: 'AIA SG',
                roleName: 'AIA SG role',
                legalEntities: []
            },
            {
                roleID: 'AIA TW',
                roleName: 'AIA TW role',
                legalEntities: []
            },
            {
                roleID: 'AIA TH',
                roleName: 'AIA TH role',
                legalEntities: []
            },
            {
                roleID: 'AIA HK',
                roleName: 'AIA HK role',
                legalEntities: []
            },
            {
                roleID: 'AIA KR',
                roleName: 'AIA KR role',
                legalEntities: []
            },
            {
                roleID: 'AIA AU',
                roleName: 'AIA AU role',
                legalEntities: []
            }
        ];
    }

    private getFakeTradesData() {
        return {

            "aampProductInfoList": null,

            "aampProductInfoSimuList": null,

            "derivativeHoldings": null,

            "aampQuotas": null,

            "entityCounterPartyCcrAndEces": null,

            "counterPartyDerivativeVsCollaterals": null,

            "wccrPeriods": null,

            "instrumentGridItems": null,

            "countryLevelTails": null,

            "rolloverToCashSetting": null,

            "entityTrades": [

                {

                    "modelId": "3622f5af-1846-4cea-a6ee-69a97bbabf82",

                    "modelName": "Test 1",

                    "userName": "40684632",

                    "createdDate": 1598220000000,

                    "status": "Completed",

                    "tradeInstruments": null,

                    "counterpartyTradeValues": null

                }

            ],

            "derivativeExposureResponse": null,

            "legalEntityAndCounterPartySummaryResponse": null,

            "lowestTenCcrsAndShockedCcrsList": null,

            "lowestWccrList": null,

            "tradeInstruments": null,

            "fxRates": null,

            "notifs": null,

            "latestFiles": null,

            "otcEio": null,

            "otcFxo": null,

            "runIds": null,

            "query": null,

            "simuProductNotional": null

        }
    }

    private getFakeUserData() {
        return {
            "id": "d51759",
            "firstName": null,
            "lastName": null,
            "legalEntities": [
                {
                    "rowKey": null,
                    "entityId": "E29",
                    "dataName": "AIAI - HK (Par X CM CCP)",
                    "name": "HK (Par X CM CCP)",
                    "code": "HK (Par X CM CCP)",
                    "counterParties": ["BNP Paribas"],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E50",
                    "dataName": "AIA Dummy 5(T)",
                    "name": "AIA Dummy 5(T)",
                    "code": "AIA Dummy 5(T)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E46",
                    "dataName": "AIA Dummy 1(T)",
                    "name": "AIA Dummy 1(T)",
                    "code": "AIA Dummy 1(T)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E48",
                    "dataName": "AIA Dummy 3(T)",
                    "name": "AIA Dummy 3(T)",
                    "code": "AIA Dummy 3(T)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E30",
                    "dataName": "AIAI - HK (Par X CM)",
                    "name": "HK (Par X CM)",
                    "code": "HK (Par X CM)",
                    "counterParties": [
                        "CACIB",
                        "Standard Chartered",
                        "Barclays",
                        "Deutsche",
                        "JP Morgan",
                        "Goldman Sachs",
                        "HSBC",
                        "Morgan Stanley",
                        "BNP Paribas"
                    ],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E15",
                    "dataName": "AIAI - HK (Par L)",
                    "name": "HK (Par L)",
                    "code": "HK (Par L)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E13",
                    "dataName": "AIAI - HK (Par H)",
                    "name": "HK (Par H)",
                    "code": "HK (Par H)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E5",
                    "dataName": "AIA Australia",
                    "name": "Australia",
                    "code": "AUS",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E22",
                    "dataName": "AIAI - KOREA (GA)",
                    "name": "Korea (GA)",
                    "code": "KOREA (GA)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E31",
                    "dataName": "AIA PH (NPar)",
                    "name": "PH (NPar)",
                    "code": "PH (NPar)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E23",
                    "dataName": "AIAI - HK (Par H CM CCP)",
                    "name": "HK (Par H CM CCP)",
                    "code": "HK (Par H CM CCP)",
                    "counterParties": ["BNP Paribas"],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E28",
                    "dataName": "AIAI - HK (Par M CM)",
                    "name": "HK (Par M CM)",
                    "code": "HK (Par M CM)",
                    "counterParties": [
                        "CACIB",
                        "Standard Chartered",
                        "Barclays",
                        "Societe Generale",
                        "Deutsche",
                        "JP Morgan",
                        "Goldman Sachs",
                        "HSBC",
                        "Morgan Stanley",
                        "BNP Paribas"
                    ],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E24",
                    "dataName": "AIAI - HK (Par H CM)",
                    "name": "HK (Par H CM)",
                    "code": "HK (Par H CM)",
                    "counterParties": [
                        "Standard Chartered",
                        "Deutsche",
                        "JP Morgan",
                        "Goldman Sachs",
                        "HSBC",
                        "Morgan Stanley",
                        "BNP Paribas"
                    ],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E2",
                    "dataName": "AIA Group",
                    "name": "Group",
                    "code": "GROUP",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E9",
                    "dataName": "AIAI - HO",
                    "name": "HO",
                    "code": "HO",
                    "counterParties": [
                        "Citigroup",
                        "HSBC",
                        "BNP Paribas"
                    ],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E21",
                    "dataName": "AIAI - KOREA (AL)",
                    "name": "Korea (AL)",
                    "code": "KOREA (AL)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E26",
                    "dataName": "AIAI - HK (Par L CM)",
                    "name": "HK (Par L CM)",
                    "code": "HK (Par L CM)",
                    "counterParties": [
                        "Standard Chartered",
                        "JP Morgan",
                        "Morgan Stanley",
                        "BNP Paribas"
                    ],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E27",
                    "dataName": "AIAI - HK (Par M CM CCP)",
                    "name": "HK (Par M CM CCP)",
                    "code": "HK (Par M CM CCP)",
                    "counterParties": ["BNP Paribas"],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E3",
                    "dataName": "AIAI - HK (NPar)",
                    "name": "HK (NPar)",
                    "code": "HK (NPar)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E17",
                    "dataName": "AIAI - HK (Par M)",
                    "name": "HK (Par M)",
                    "code": "HK (Par M)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E47",
                    "dataName": "AIA Dummy 2(T)",
                    "name": "AIA Dummy 2(T)",
                    "code": "AIA Dummy 2(T)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E49",
                    "dataName": "AIA Dummy 4(T)",
                    "name": "AIA Dummy 4(T)",
                    "code": "AIA Dummy 4(T)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E10",
                    "dataName": "AIA Singapore (Par)",
                    "name": "Singapore (Par)",
                    "code": "SG (Par)",
                    "counterParties": [
                        "NDBS",
                        "DBS"
                    ],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E1",
                    "dataName": "AIA Singapore (NPar)",
                    "name": "Singapore (NPar)",
                    "code": "SG (NPar)",
                    "counterParties": [
                        "NDBS",
                        "DBS"
                    ],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E11",
                    "dataName": "AIA CO LTD - SF",
                    "name": "SF",
                    "code": "SF",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E6",
                    "dataName": "AIA Taiwan",
                    "name": "Taiwan",
                    "code": "TAI",
                    "counterParties": [
                        "Citigroup",
                        "First Commercial",
                        "Taipei Fubon Commercial",
                        "China Trust"
                    ],
                    "ccrOrExpo": 0
                },
                {
                    "rowKey": null,
                    "entityId": "E7",
                    "dataName": "AIA Thailand",
                    "name": "Thailand",
                    "code": "THAI",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                },
                {
                    "rowKey": null,
                    "entityId": "E19",
                    "dataName": "AIAI - HK (Par X)",
                    "name": "HK (Par X)",
                    "code": "HK (Par X)",
                    "counterParties": ["ALL"],
                    "ccrOrExpo": 1
                }
            ],
            "queryConfig": {
                "rolloverToCash": false,
                "entityTailConfigs": [
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E29",
                            "dataName": "AIAI - HK (Par X CM CCP)",
                            "name": "HK (Par X CM CCP)",
                            "code": "HK (Par X CM CCP)",
                            "counterParties": ["BNP Paribas"],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "34dfe528-c64f-455b-a2e1-aa8b87d32505",
                            "from": 0,
                            "to": 24,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par X CM CCP)",
                            "entityId": "E29"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E50",
                            "dataName": "AIA Dummy 5(T)",
                            "name": "AIA Dummy 5(T)",
                            "code": "AIA Dummy 5(T)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "36d064b1-ec61-4c88-8755-59531864ca7a",
                            "from": 0,
                            "to": 120,
                            "tail": 0.005,
                            "entityName": "AIA Dummy 5(T)",
                            "entityId": "E50"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E46",
                            "dataName": "AIA Dummy 1(T)",
                            "name": "AIA Dummy 1(T)",
                            "code": "AIA Dummy 1(T)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "7ae1d3e6-7ba6-40d5-a783-8e3f4878d208",
                            "from": 0,
                            "to": 120,
                            "tail": 0.005,
                            "entityName": "AIA Dummy 1(T)",
                            "entityId": "E46"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E48",
                            "dataName": "AIA Dummy 3(T)",
                            "name": "AIA Dummy 3(T)",
                            "code": "AIA Dummy 3(T)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "5ef21aeb-b266-4d6e-8864-418ff53bbbf5",
                            "from": 0,
                            "to": 120,
                            "tail": 0.005,
                            "entityName": "AIA Dummy 3(T)",
                            "entityId": "E48"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E30",
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": [
                                "CACIB",
                                "Standard Chartered",
                                "Barclays",
                                "Deutsche",
                                "JP Morgan",
                                "Goldman Sachs",
                                "HSBC",
                                "Morgan Stanley",
                                "BNP Paribas"
                            ],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "9153de27-6308-40bb-a55d-d2aa6f7fc3e1",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par X CM)",
                            "entityId": "E30"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E15",
                            "dataName": "AIAI - HK (Par L)",
                            "name": "HK (Par L)",
                            "code": "HK (Par L)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "E15",
                            "from": 0,
                            "to": 3,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par L)",
                            "entityId": "E15"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E13",
                            "dataName": "AIAI - HK (Par H)",
                            "name": "HK (Par H)",
                            "code": "HK (Par H)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "E13",
                            "from": 0,
                            "to": 3,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par H)",
                            "entityId": "E13"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E5",
                            "dataName": "AIA Australia",
                            "name": "Australia",
                            "code": "AUS",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "f975d38b-4f90-4920-83ae-1456fda9c3e5",
                            "from": 0,
                            "to": 12,
                            "tail": 0.005,
                            "entityName": "AIA Australia",
                            "entityId": "E5"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E22",
                            "dataName": "AIAI - KOREA (GA)",
                            "name": "Korea (GA)",
                            "code": "KOREA (GA)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "E22",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - KOREA (GA)",
                            "entityId": "E22"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E31",
                            "dataName": "AIA PH (NPar)",
                            "name": "PH (NPar)",
                            "code": "PH (NPar)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "5478ee33-ba24-4a68-b6b9-c11dc3657302",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIA PH (NPar)",
                            "entityId": "E31"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E23",
                            "dataName": "AIAI - HK (Par H CM CCP)",
                            "name": "HK (Par H CM CCP)",
                            "code": "HK (Par H CM CCP)",
                            "counterParties": ["BNP Paribas"],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "492a4dce-3e9e-4351-86d2-d23c21f8c941",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par H CM CCP)",
                            "entityId": "E23"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E28",
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": [
                                "CACIB",
                                "Standard Chartered",
                                "Barclays",
                                "Societe Generale",
                                "Deutsche",
                                "JP Morgan",
                                "Goldman Sachs",
                                "HSBC",
                                "Morgan Stanley",
                                "BNP Paribas"
                            ],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "965e5603-c7fc-4cfa-8bf3-ffc6af91d0ec",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par M CM)",
                            "entityId": "E28"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E24",
                            "dataName": "AIAI - HK (Par H CM)",
                            "name": "HK (Par H CM)",
                            "code": "HK (Par H CM)",
                            "counterParties": [
                                "Standard Chartered",
                                "Deutsche",
                                "JP Morgan",
                                "Goldman Sachs",
                                "HSBC",
                                "Morgan Stanley",
                                "BNP Paribas"
                            ],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "26ef1802-4e38-4650-942f-3b8fc79a6323",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par H CM)",
                            "entityId": "E24"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E2",
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "f33b5135-001d-4885-9d46-73f34b23d52c",
                            "from": 0,
                            "to": 12,
                            "tail": 0.005,
                            "entityName": "AIA Group",
                            "entityId": "E2"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E9",
                            "dataName": "AIAI - HO",
                            "name": "HO",
                            "code": "HO",
                            "counterParties": [
                                "Citigroup",
                                "HSBC",
                                "BNP Paribas"
                            ],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "E9",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HO",
                            "entityId": "E9"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E21",
                            "dataName": "AIAI - KOREA (AL)",
                            "name": "Korea (AL)",
                            "code": "KOREA (AL)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "0dbac5b9-9852-4d80-878c-8f338f18c68f",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - KOREA (AL)",
                            "entityId": "E21"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E26",
                            "dataName": "AIAI - HK (Par L CM)",
                            "name": "HK (Par L CM)",
                            "code": "HK (Par L CM)",
                            "counterParties": [
                                "Standard Chartered",
                                "JP Morgan",
                                "Morgan Stanley",
                                "BNP Paribas"
                            ],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "6785f9d5-0493-413c-a50b-38b57a5fcd3e",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par L CM)",
                            "entityId": "E26"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E27",
                            "dataName": "AIAI - HK (Par M CM CCP)",
                            "name": "HK (Par M CM CCP)",
                            "code": "HK (Par M CM CCP)",
                            "counterParties": ["BNP Paribas"],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "96e45c3e-f325-40d4-ad19-c25f7b39619c",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par M CM CCP)",
                            "entityId": "E27"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E3",
                            "dataName": "AIAI - HK (NPar)",
                            "name": "HK (NPar)",
                            "code": "HK (NPar)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "985985e3-124f-4546-858d-7690c6224b4e",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (NPar)",
                            "entityId": "E3"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E17",
                            "dataName": "AIAI - HK (Par M)",
                            "name": "HK (Par M)",
                            "code": "HK (Par M)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "2ab2ef09-6fdf-44b8-98bc-754683c8ea7e",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par M)",
                            "entityId": "E17"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E47",
                            "dataName": "AIA Dummy 2(T)",
                            "name": "AIA Dummy 2(T)",
                            "code": "AIA Dummy 2(T)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "9074af56-c7a7-4079-a3ad-2090c099b2af",
                            "from": 0,
                            "to": 120,
                            "tail": 0.005,
                            "entityName": "AIA Dummy 2(T)",
                            "entityId": "E47"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E49",
                            "dataName": "AIA Dummy 4(T)",
                            "name": "AIA Dummy 4(T)",
                            "code": "AIA Dummy 4(T)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "33e6e046-cb26-4470-a164-fd5a68b91b0d",
                            "from": 0,
                            "to": 120,
                            "tail": 0.005,
                            "entityName": "AIA Dummy 4(T)",
                            "entityId": "E49"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E10",
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": [
                                "NDBS",
                                "DBS"
                            ],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "E10",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIA Singapore (Par)",
                            "entityId": "E10"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E1",
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": [
                                "NDBS",
                                "DBS"
                            ],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "7712a737-5bd2-40ad-a735-01cb4ed8ce08",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIA Singapore (NPar)",
                            "entityId": "E1"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E11",
                            "dataName": "AIA CO LTD - SF",
                            "name": "SF",
                            "code": "SF",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "0264e9bf-7ec3-4553-808b-93aa6c8385a8",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIA CO LTD - SF",
                            "entityId": "E11"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E6",
                            "dataName": "AIA Taiwan",
                            "name": "Taiwan",
                            "code": "TAI",
                            "counterParties": [
                                "Citigroup",
                                "First Commercial",
                                "Taipei Fubon Commercial",
                                "China Trust"
                            ],
                            "ccrOrExpo": 0
                        },
                        "yearRangeTails": [{
                            "rowKey": "71c370f9-e254-4fe7-bab7-9f1f8992a66c",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIA Taiwan",
                            "entityId": "E6"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E7",
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "E7",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIA Thailand",
                            "entityId": "E7"
                        }]
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": "E19",
                            "dataName": "AIAI - HK (Par X)",
                            "name": "HK (Par X)",
                            "code": "HK (Par X)",
                            "counterParties": ["ALL"],
                            "ccrOrExpo": 1
                        },
                        "yearRangeTails": [{
                            "rowKey": "2b51d0bf-3f7f-4a88-905c-029e51d4d7db",
                            "from": 0,
                            "to": 1,
                            "tail": 0.005,
                            "entityName": "AIAI - HK (Par X)",
                            "entityId": "E19"
                        }]
                    }
                ],
                "groupTailConfig": [{
                    "rowKey": null,
                    "from": 0,
                    "to": 120,
                    "tail": 0.2,
                    "entityName": null,
                    "entityId": null
                }],
                "rolloverConfigRowKey": "row key"
            }
        };
    }

    private getFakeCCrAndEceData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": [
                {
                    "counterParty": "ALL",
                    "ccr": 191098.38,
                    "timeStep": 0,
                    "timeStepDate": 1648677600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -0.3,
                    "occur": "Q1 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 15713.21,
                    "timeStep": 0.25,
                    "timeStepDate": 1649282400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -3.55,
                    "occur": "Q2 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 15774.58,
                    "timeStep": 0.5,
                    "timeStepDate": 1649887200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -3.54,
                    "occur": "Q2 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 12113.01,
                    "timeStep": 1,
                    "timeStepDate": 1651269600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -4.42,
                    "occur": "Q2 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 8285.64,
                    "timeStep": 2,
                    "timeStepDate": 1653948000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -6.14,
                    "occur": "Q2 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 6688.31,
                    "timeStep": 3,
                    "timeStepDate": 1656540000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.47,
                    "occur": "Q2 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5965.32,
                    "timeStep": 4,
                    "timeStepDate": 1659218400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.18,
                    "occur": "Q3 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5216.86,
                    "timeStep": 5,
                    "timeStepDate": 1661896800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -9.77,
                    "occur": "Q3 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 8654.64,
                    "timeStep": 6,
                    "timeStepDate": 1664488800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -5.52,
                    "occur": "Q3 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 7004.59,
                    "timeStep": 9,
                    "timeStepDate": 1672441200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -6.59,
                    "occur": "Q4 2022",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 6348.16,
                    "timeStep": 12,
                    "timeStepDate": 1680213600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -6.96,
                    "occur": "Q1 2023",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5399.36,
                    "timeStep": 15,
                    "timeStepDate": 1688076000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.18,
                    "occur": "Q2 2023",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5247.34,
                    "timeStep": 18,
                    "timeStepDate": 1696024800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.05,
                    "occur": "Q3 2023",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4910.8,
                    "timeStep": 21,
                    "timeStepDate": 1703977200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.45,
                    "occur": "Q4 2023",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 6287.28,
                    "timeStep": 24,
                    "timeStepDate": 1711839600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.01,
                    "occur": "Q1 2024",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5928.75,
                    "timeStep": 27,
                    "timeStepDate": 1719698400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -6.9,
                    "occur": "Q2 2024",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5443.46,
                    "timeStep": 30,
                    "timeStepDate": 1727647200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.52,
                    "occur": "Q3 2024",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5219.74,
                    "timeStep": 33,
                    "timeStepDate": 1735599600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.56,
                    "occur": "Q4 2024",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4960.01,
                    "timeStep": 36,
                    "timeStepDate": 1743372000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.62,
                    "occur": "Q1 2025",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4788.61,
                    "timeStep": 39,
                    "timeStepDate": 1751234400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.54,
                    "occur": "Q2 2025",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4612.37,
                    "timeStep": 42,
                    "timeStepDate": 1759183200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.21,
                    "occur": "Q3 2025",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4324.9,
                    "timeStep": 45,
                    "timeStepDate": 1767135600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.45,
                    "occur": "Q4 2025",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4381.22,
                    "timeStep": 48,
                    "timeStepDate": 1774908000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -7.97,
                    "occur": "Q1 2026",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4233.4,
                    "timeStep": 51,
                    "timeStepDate": 1782770400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.5,
                    "occur": "Q2 2026",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3825.16,
                    "timeStep": 54,
                    "timeStepDate": 1790719200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -9.01,
                    "occur": "Q3 2026",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3700.92,
                    "timeStep": 57,
                    "timeStepDate": 1798671600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.17,
                    "occur": "Q4 2026",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3525.19,
                    "timeStep": 60,
                    "timeStepDate": 1806444000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.84,
                    "occur": "Q1 2027",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3435.93,
                    "timeStep": 63,
                    "timeStepDate": 1814306400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.84,
                    "occur": "Q2 2027",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3602.78,
                    "timeStep": 66,
                    "timeStepDate": 1822255200000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.21,
                    "occur": "Q3 2027",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3487.09,
                    "timeStep": 69,
                    "timeStepDate": 1830207600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.83,
                    "occur": "Q4 2027",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3315.41,
                    "timeStep": 72,
                    "timeStepDate": 1838066400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.26,
                    "occur": "Q1 2028",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3143.15,
                    "timeStep": 75,
                    "timeStepDate": 1845928800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.64,
                    "occur": "Q2 2028",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 2618.8,
                    "timeStep": 78,
                    "timeStepDate": 1853877600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -9.52,
                    "occur": "Q3 2028",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 2663.99,
                    "timeStep": 81,
                    "timeStepDate": 1861830000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -8.82,
                    "occur": "Q4 2028",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 3692.36,
                    "timeStep": 84,
                    "timeStepDate": 1869602400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -6.5,
                    "occur": "Q1 2029",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4486.41,
                    "timeStep": 87,
                    "timeStepDate": 1877464800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -5.25,
                    "occur": "Q2 2029",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5349.93,
                    "timeStep": 90,
                    "timeStepDate": 1885413600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -4.69,
                    "occur": "Q3 2029",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 5570.87,
                    "timeStep": 93,
                    "timeStepDate": 1893366000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -4.68,
                    "occur": "Q4 2029",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 8054.21,
                    "timeStep": 96,
                    "timeStepDate": 1901142000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -3.04,
                    "occur": "Q1 2030",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 7643.59,
                    "timeStep": 99,
                    "timeStepDate": 1909000800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -2.92,
                    "occur": "Q2 2030",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 7618.45,
                    "timeStep": 102,
                    "timeStepDate": 1916949600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -3.15,
                    "occur": "Q3 2030",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 6982.98,
                    "timeStep": 105,
                    "timeStepDate": 1924902000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -3.03,
                    "occur": "Q4 2030",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 7270.64,
                    "timeStep": 108,
                    "timeStepDate": 1932674400000,
                    "w2Var": 3.34,
                    "peakLiqExp": -3.19,
                    "occur": "Q1 2031",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4549.05,
                    "timeStep": 111,
                    "timeStepDate": 1940536800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -2.7,
                    "occur": "Q2 2031",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4422.47,
                    "timeStep": 114,
                    "timeStepDate": 1948485600000,
                    "w2Var": 3.34,
                    "peakLiqExp": -2.78,
                    "occur": "Q3 2031",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4520.36,
                    "timeStep": 117,
                    "timeStepDate": 1956438000000,
                    "w2Var": 3.34,
                    "peakLiqExp": -2.95,
                    "occur": "Q4 2031",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 4584.27,
                    "timeStep": 120,
                    "timeStepDate": 1964296800000,
                    "w2Var": 3.34,
                    "peakLiqExp": -2.84,
                    "occur": "Q1 2032",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                }
            ],
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        };
    }

    private getFakeIntrumentsData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": [
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "CIMB",
                    "instrumentId": "SLAR15DQ Corp",
                    "currency": "MYR",
                    "notional": "2.00 M USD",
                    "valueToday": "-370.10 k USD",
                    "minVal": "-4.01 M USD",
                    "minValDate": "31/12/2027",
                    "maxVal": "8.62 M USD",
                    "maxValDate": "31/03/2031",
                    "valDiff": "-3.14 M USD",
                    "valDiffDate": "31/03/2027",
                    "expiry": "2048-09-25"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGY2100027",
                    "currency": "MYR",
                    "notional": "18.98 M USD",
                    "valueToday": "18.92 M USD",
                    "minVal": "5.74 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "68.08 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "7.70 M USD",
                    "valDiffDate": "30/06/2031",
                    "expiry": "2041-09-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMY1900052",
                    "currency": "MYR",
                    "notional": "25.77 M USD",
                    "valueToday": "23.67 M USD",
                    "minVal": "7.39 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "87.11 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "10.24 M USD",
                    "valDiffDate": "31/03/2031",
                    "expiry": "2040-05-22"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGY1900021",
                    "currency": "MYR",
                    "notional": "1.19 M USD",
                    "valueToday": "1.18 M USD",
                    "minVal": "349.70 k USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "4.10 M USD",
                    "maxValDate": "31/12/2031",
                    "valDiff": "497.01 k USD",
                    "valDiffDate": "31/03/2032",
                    "expiry": "2039-09-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX1800049",
                    "currency": "MYR",
                    "notional": "14.48 M USD",
                    "valueToday": "15.24 M USD",
                    "minVal": "4.33 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "50.23 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "6.29 M USD",
                    "valDiffDate": "30/09/2031",
                    "expiry": "2038-06-08"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGX1700050",
                    "currency": "MYR",
                    "notional": "5.22 M USD",
                    "valueToday": "5.39 M USD",
                    "minVal": "1.52 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "18.24 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "2.26 M USD",
                    "valDiffDate": "31/12/2031",
                    "expiry": "2037-08-04"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX1700033",
                    "currency": "MYR",
                    "notional": "4.75 M USD",
                    "valueToday": "5.01 M USD",
                    "minVal": "1.40 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "17.04 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "2.07 M USD",
                    "valDiffDate": "31/03/2031",
                    "expiry": "2037-04-07"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMY1500043",
                    "currency": "MYR",
                    "notional": "23.97 M USD",
                    "valueToday": "23.87 M USD",
                    "minVal": "6.73 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "86.84 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "10.08 M USD",
                    "valDiffDate": "31/03/2031",
                    "expiry": "2035-05-31"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMT1800039",
                    "currency": "MYR",
                    "notional": "38.51 M USD",
                    "valueToday": "40.07 M USD",
                    "minVal": "10.72 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "142.45 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "16.22 M USD",
                    "valDiffDate": "30/09/2031",
                    "expiry": "2033-11-07"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGX1300687",
                    "currency": "MYR",
                    "notional": "8.12 M USD",
                    "valueToday": "8.40 M USD",
                    "minVal": "2.22 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "29.60 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "3.38 M USD",
                    "valDiffDate": "31/03/2032",
                    "expiry": "2033-08-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGT1700066",
                    "currency": "MYR",
                    "notional": "8.04 M USD",
                    "valueToday": "8.42 M USD",
                    "minVal": "2.22 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "29.56 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "3.36 M USD",
                    "valDiffDate": "31/03/2032",
                    "expiry": "2033-06-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX1300040",
                    "currency": "MYR",
                    "notional": "60.45 M USD",
                    "valueToday": "58.74 M USD",
                    "minVal": "16.54 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "220.58 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "24.99 M USD",
                    "valDiffDate": "31/03/2031",
                    "expiry": "2033-04-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMO2200016",
                    "currency": "MYR",
                    "notional": "28.48 M USD",
                    "valueToday": "27.82 M USD",
                    "minVal": "7.66 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "101.77 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "11.61 M USD",
                    "valDiffDate": "30/06/2031",
                    "expiry": "2032-07-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX1200042",
                    "currency": "MYR",
                    "notional": "37.73 M USD",
                    "valueToday": "38.05 M USD",
                    "minVal": "10.24 M USD",
                    "minValDate": "31/03/2032",
                    "maxVal": "135.80 M USD",
                    "maxValDate": "31/03/2032",
                    "valDiff": "15.44 M USD",
                    "valDiffDate": "30/09/2031",
                    "expiry": "2032-04-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX1100044",
                    "currency": "MYR",
                    "notional": "154.96 M USD",
                    "valueToday": "158.05 M USD",
                    "minVal": "53.24 M USD",
                    "minValDate": "31/03/2031",
                    "maxVal": "484.27 M USD",
                    "maxValDate": "31/03/2031",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/06/2031",
                    "expiry": "2031-06-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMO2000028",
                    "currency": "MYR",
                    "notional": "11.87 M USD",
                    "valueToday": "10.73 M USD",
                    "minVal": "4.07 M USD",
                    "minValDate": "31/03/2031",
                    "maxVal": "36.99 M USD",
                    "maxValDate": "31/03/2031",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/06/2031",
                    "expiry": "2031-04-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGO2000020",
                    "currency": "MYR",
                    "notional": "19.70 M USD",
                    "valueToday": "19.08 M USD",
                    "minVal": "6.94 M USD",
                    "minValDate": "30/09/2030",
                    "maxVal": "56.83 M USD",
                    "maxValDate": "30/09/2030",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2031",
                    "expiry": "2030-10-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGT1500037",
                    "currency": "MYR",
                    "notional": "3.56 M USD",
                    "valueToday": "3.64 M USD",
                    "minVal": "1.28 M USD",
                    "minValDate": "30/06/2030",
                    "maxVal": "10.14 M USD",
                    "maxValDate": "31/03/2030",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/09/2030",
                    "expiry": "2030-09-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX1000038",
                    "currency": "MYR",
                    "notional": "29.66 M USD",
                    "valueToday": "30.91 M USD",
                    "minVal": "10.74 M USD",
                    "minValDate": "31/03/2030",
                    "maxVal": "85.45 M USD",
                    "maxValDate": "31/03/2030",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/06/2030",
                    "expiry": "2030-04-15"
                },
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "CIMB",
                    "instrumentId": "SLSE17MU Corp",
                    "currency": "MYR",
                    "notional": "2.90 M USD",
                    "valueToday": "132.66 k USD",
                    "minVal": "-1.71 M USD",
                    "minValDate": "31/12/2029",
                    "maxVal": "5.84 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "-1.44 M USD",
                    "valDiffDate": "30/06/2029",
                    "expiry": "2030-01-21"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMO1900020",
                    "currency": "MYR",
                    "notional": "5.58 M USD",
                    "valueToday": "5.58 M USD",
                    "minVal": "2.18 M USD",
                    "minValDate": "31/03/2029",
                    "maxVal": "14.50 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2030",
                    "expiry": "2029-08-15"
                },
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "SLAR15DH Corp",
                    "currency": "MYR",
                    "notional": "2.00 M USD",
                    "valueToday": "18.45 k USD",
                    "minVal": "-1.18 M USD",
                    "minValDate": "31/03/2029",
                    "maxVal": "3.71 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "-1.03 M USD",
                    "valDiffDate": "30/06/2029",
                    "expiry": "2029-07-18"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGO1900014",
                    "currency": "MYR",
                    "notional": "1.19 M USD",
                    "valueToday": "1.20 M USD",
                    "minVal": "464.35 k USD",
                    "minValDate": "31/03/2029",
                    "maxVal": "3.10 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2029",
                    "expiry": "2029-07-09"
                },
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "SLAR15DZ Corp",
                    "currency": "MYR",
                    "notional": "2.50 M USD",
                    "valueToday": "99.93 k USD",
                    "minVal": "-1.45 M USD",
                    "minValDate": "31/03/2029",
                    "maxVal": "4.64 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "-1.25 M USD",
                    "valDiffDate": "31/03/2029",
                    "expiry": "2029-06-24"
                },
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "CIMB",
                    "instrumentId": "SLAR15CT Corp",
                    "currency": "MYR",
                    "notional": "5.00 M USD",
                    "valueToday": "-21.33 k USD",
                    "minVal": "-3.06 M USD",
                    "minValDate": "30/09/2028",
                    "maxVal": "9.06 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "-2.54 M USD",
                    "valDiffDate": "31/12/2028",
                    "expiry": "2029-01-16"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMX0800032",
                    "currency": "MYR",
                    "notional": "70.72 M USD",
                    "valueToday": "76.52 M USD",
                    "minVal": "27.96 M USD",
                    "minValDate": "30/06/2028",
                    "maxVal": "182.68 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2028",
                    "expiry": "2028-09-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGT1300016",
                    "currency": "MYR",
                    "notional": "2.14 M USD",
                    "valueToday": "2.14 M USD",
                    "minVal": "839.37 k USD",
                    "minValDate": "30/06/2028",
                    "maxVal": "5.49 M USD",
                    "maxValDate": "30/06/2028",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2028",
                    "expiry": "2028-08-08"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMO1700040",
                    "currency": "MYR",
                    "notional": "166.11 k USD",
                    "valueToday": "169.32 k USD",
                    "minVal": "73.00 k USD",
                    "minValDate": "30/09/2027",
                    "maxVal": "399.56 k USD",
                    "maxValDate": "30/09/2027",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2027",
                    "expiry": "2027-11-16"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGL2000018",
                    "currency": "MYR",
                    "notional": "427.14 k USD",
                    "valueToday": "426.23 k USD",
                    "minVal": "189.79 k USD",
                    "minValDate": "30/06/2027",
                    "maxVal": "965.46 k USD",
                    "maxValDate": "30/06/2027",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2027",
                    "expiry": "2027-09-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGO1700018",
                    "currency": "MYR",
                    "notional": "1.87 M USD",
                    "valueToday": "1.94 M USD",
                    "minVal": "838.71 k USD",
                    "minValDate": "30/06/2027",
                    "maxVal": "4.27 M USD",
                    "maxValDate": "30/06/2027",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2028",
                    "expiry": "2027-07-26"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMO1600034",
                    "currency": "MYR",
                    "notional": "24.44 M USD",
                    "valueToday": "24.99 M USD",
                    "minVal": "11.87 M USD",
                    "minValDate": "30/06/2026",
                    "maxVal": "55.35 M USD",
                    "maxValDate": "30/06/2026",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2026",
                    "expiry": "2026-11-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGO1600036",
                    "currency": "MYR",
                    "notional": "142.38 k USD",
                    "valueToday": "146.12 k USD",
                    "minVal": "69.54 k USD",
                    "minValDate": "30/06/2026",
                    "maxVal": "323.96 k USD",
                    "maxValDate": "30/06/2026",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2027",
                    "expiry": "2026-09-30"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMS1100036",
                    "currency": "MYR",
                    "notional": "156.62 k USD",
                    "valueToday": "162.70 k USD",
                    "minVal": "78.81 k USD",
                    "minValDate": "31/03/2026",
                    "maxVal": "333.52 k USD",
                    "maxValDate": "31/03/2026",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2027",
                    "expiry": "2026-04-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGO1500046",
                    "currency": "MYR",
                    "notional": "972.94 k USD",
                    "valueToday": "998.47 k USD",
                    "minVal": "446.27 k USD",
                    "minValDate": "30/06/2025",
                    "maxVal": "1.96 M USD",
                    "maxValDate": "30/06/2025",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2025",
                    "expiry": "2025-10-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMO1500010",
                    "currency": "MYR",
                    "notional": "4.75 M USD",
                    "valueToday": "4.87 M USD",
                    "minVal": "2.16 M USD",
                    "minValDate": "31/03/2025",
                    "maxVal": "9.59 M USD",
                    "maxValDate": "30/06/2025",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2026",
                    "expiry": "2025-09-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGL1800012",
                    "currency": "MYR",
                    "notional": "237.30 k USD",
                    "valueToday": "244.43 k USD",
                    "minVal": "108.14 k USD",
                    "minValDate": "31/03/2025",
                    "maxVal": "480.94 k USD",
                    "maxValDate": "30/06/2025",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/12/2025",
                    "expiry": "2025-08-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMY0500036",
                    "currency": "MYR",
                    "notional": "6.88 M USD",
                    "valueToday": "7.24 M USD",
                    "minVal": "3.15 M USD",
                    "minValDate": "31/03/2025",
                    "maxVal": "14.02 M USD",
                    "maxValDate": "30/06/2025",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2026",
                    "expiry": "2025-07-15"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMK1800012",
                    "currency": "MYR",
                    "notional": "7.12 M USD",
                    "valueToday": "7.27 M USD",
                    "minVal": "3.46 M USD",
                    "minValDate": "31/12/2024",
                    "maxVal": "12.28 M USD",
                    "maxValDate": "31/12/2024",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "31/03/2025",
                    "expiry": "2025-03-14"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBMI1900030",
                    "currency": "MYR",
                    "notional": "4.75 M USD",
                    "valueToday": "4.82 M USD",
                    "minVal": "2.98 M USD",
                    "minValDate": "31/03/2024",
                    "maxVal": "7.96 M USD",
                    "maxValDate": "31/03/2024",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/06/2024",
                    "expiry": "2024-06-14"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBGO1300710",
                    "currency": "MYR",
                    "notional": "379.69 k USD",
                    "valueToday": "392.55 k USD",
                    "minVal": "239.66 k USD",
                    "minValDate": "31/03/2024",
                    "maxVal": "640.79 k USD",
                    "maxValDate": "31/03/2024",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/06/2024",
                    "expiry": "2024-05-22"
                },
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "SLAR15D5 Corp",
                    "currency": "MYR",
                    "notional": "5.00 M USD",
                    "valueToday": "-68.88 k USD",
                    "minVal": "-2.01 M USD",
                    "minValDate": "31/12/2023",
                    "maxVal": "2.86 M USD",
                    "maxValDate": "30/09/2023",
                    "valDiff": "-1.51 M USD",
                    "valDiffDate": "30/09/2023",
                    "expiry": "2024-03-29"
                },
                {
                    "type": "Derivative",
                    "product": "CCS",
                    "counterParty": "CIMB",
                    "instrumentId": "SLAR15CQ Corp",
                    "currency": "MYR",
                    "notional": "2.90 M USD",
                    "valueToday": "-57.24 k USD",
                    "minVal": "-1.15 M USD",
                    "minValDate": "31/12/2023",
                    "maxVal": "1.60 M USD",
                    "maxValDate": "30/09/2023",
                    "valDiff": "-871.97 k USD",
                    "valDiffDate": "30/09/2023",
                    "expiry": "2024-02-19"
                },
                {
                    "type": "Collateral",
                    "product": "Fixed Bond",
                    "counterParty": "ALL",
                    "instrumentId": "MYBML1600014",
                    "currency": "MYR",
                    "notional": "7.12 M USD",
                    "valueToday": "7.28 M USD",
                    "minVal": "4.67 M USD",
                    "minValDate": "31/03/2023",
                    "maxVal": "10.74 M USD",
                    "maxValDate": "30/06/2023",
                    "valDiff": "0.0 USD",
                    "valDiffDate": "30/09/2023",
                    "expiry": "2023-08-17"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000611 Curncy",
                    "currency": "MYR",
                    "notional": "2.45 M USD",
                    "valueToday": "-12.94 k USD",
                    "minVal": "-558.20 k USD",
                    "minValDate": "31/08/2022",
                    "maxVal": "714.84 k USD",
                    "maxValDate": "31/07/2022",
                    "valDiff": "-359.97 k USD",
                    "valDiffDate": "31/07/2022",
                    "expiry": "2022-09-08"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000610 Curncy",
                    "currency": "MYR",
                    "notional": "4.25 M USD",
                    "valueToday": "-22.40 k USD",
                    "minVal": "-966.44 k USD",
                    "minValDate": "31/08/2022",
                    "maxVal": "1.24 M USD",
                    "maxValDate": "31/07/2022",
                    "valDiff": "-623.23 k USD",
                    "valDiffDate": "31/07/2022",
                    "expiry": "2022-09-08"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "CIMB",
                    "instrumentId": "FXF000606 Curncy",
                    "currency": "MYR",
                    "notional": "1.41 M USD",
                    "valueToday": "-4.31 k USD",
                    "minVal": "-317.61 k USD",
                    "minValDate": "31/08/2022",
                    "maxVal": "413.91 k USD",
                    "maxValDate": "31/07/2022",
                    "valDiff": "-203.71 k USD",
                    "valDiffDate": "31/07/2022",
                    "expiry": "2022-09-07"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "CIMB",
                    "instrumentId": "FXF000609 Curncy",
                    "currency": "MYR",
                    "notional": "611.45 k USD",
                    "valueToday": "-1.87 k USD",
                    "minVal": "-138.09 k USD",
                    "minValDate": "31/08/2022",
                    "maxVal": "179.96 k USD",
                    "maxValDate": "31/07/2022",
                    "valDiff": "-88.57 k USD",
                    "valDiffDate": "31/07/2022",
                    "expiry": "2022-09-07"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "CIMB",
                    "instrumentId": "FXF000608 Curncy",
                    "currency": "MYR",
                    "notional": "12.41 M USD",
                    "valueToday": "-38.05 k USD",
                    "minVal": "-2.80 M USD",
                    "minValDate": "31/08/2022",
                    "maxVal": "3.65 M USD",
                    "maxValDate": "31/07/2022",
                    "valDiff": "-1.80 M USD",
                    "valDiffDate": "31/07/2022",
                    "expiry": "2022-09-07"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "CIMB",
                    "instrumentId": "FXF000607 Curncy",
                    "currency": "MYR",
                    "notional": "5.87 M USD",
                    "valueToday": "-17.99 k USD",
                    "minVal": "-1.33 M USD",
                    "minValDate": "31/08/2022",
                    "maxVal": "1.73 M USD",
                    "maxValDate": "31/07/2022",
                    "valDiff": "-850.27 k USD",
                    "valDiffDate": "31/07/2022",
                    "expiry": "2022-09-07"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000858 Curncy",
                    "currency": "MYR",
                    "notional": "1.40 M USD",
                    "valueToday": "7.44 k USD",
                    "minVal": "-69.61 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "77.75 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-42.82 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-27"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000862 Curncy",
                    "currency": "MYR",
                    "notional": "605.59 k USD",
                    "valueToday": "3.21 k USD",
                    "minVal": "-30.00 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "33.51 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-18.46 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-27"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000859 Curncy",
                    "currency": "MYR",
                    "notional": "460.25 k USD",
                    "valueToday": "2.44 k USD",
                    "minVal": "-22.80 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "25.47 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-14.03 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-27"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000860 Curncy",
                    "currency": "MYR",
                    "notional": "484.47 k USD",
                    "valueToday": "2.57 k USD",
                    "minVal": "-24.00 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "26.81 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-14.77 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-27"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000861 Curncy",
                    "currency": "MYR",
                    "notional": "944.72 k USD",
                    "valueToday": "5.01 k USD",
                    "minVal": "-46.80 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "52.28 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-28.79 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-27"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000851 Curncy",
                    "currency": "MYR",
                    "notional": "3.72 M USD",
                    "valueToday": "10.75 k USD",
                    "minVal": "-192.95 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "196.56 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-122.16 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-26"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000852 Curncy",
                    "currency": "MYR",
                    "notional": "4.61 M USD",
                    "valueToday": "13.31 k USD",
                    "minVal": "-239.06 k USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "243.53 k USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-151.35 k USD",
                    "valDiffDate": "07/04/2022",
                    "expiry": "2022-04-26"
                },
                {
                    "type": "Derivative",
                    "product": "FX Forward",
                    "counterParty": "Standard Chartered",
                    "instrumentId": "FXF000847 Curncy",
                    "currency": "MYR",
                    "notional": "19.90 M USD",
                    "valueToday": "16.99 k USD",
                    "minVal": "-1.07 M USD",
                    "minValDate": "07/04/2022",
                    "maxVal": "1.01 M USD",
                    "maxValDate": "14/04/2022",
                    "valDiff": "-692.18 k USD",
                    "valDiffDate": "14/04/2022",
                    "expiry": "2022-04-25"
                }
            ],
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        };
    }

    private getFakeTenLowestWccrWithShockData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": [
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par M)",
                        "name": "HK (Par M)",
                        "code": "HK (Par M)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 156.48927,
                    "wccrFormatted": "156.49",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 34.6496241241731,
                    "shockedWccrFormatted": "34.65",
                    "shockedCashSF": 6362858543.237649,
                    "shockedCashSFFormatted": "6,362.86 M USD",
                    "shockedTreasurySF": 5715488429.9008465,
                    "shockedTreasurySFFormatted": "5,715.49 M USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par H)",
                        "name": "HK (Par H)",
                        "code": "HK (Par H)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 302.796,
                    "wccrFormatted": "302.80",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 114.19476355872,
                    "shockedWccrFormatted": "114.19",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par X)",
                        "name": "HK (Par X)",
                        "code": "HK (Par X)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 377.6789,
                    "wccrFormatted": "377.68",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 81.359649066624,
                    "shockedWccrFormatted": "81.36",
                    "shockedCashSF": 967252410.2862596,
                    "shockedCashSFFormatted": "967.25 M USD",
                    "shockedTreasurySF": 868842191.3229927,
                    "shockedTreasurySFFormatted": "868.84 M USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Thailand",
                        "name": "Thailand",
                        "code": "THAI",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 424.7691,
                    "wccrFormatted": "424.77",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 780.96194732724,
                    "shockedWccrFormatted": "780.96",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (NPar)",
                        "name": "HK (NPar)",
                        "code": "HK (NPar)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 491.583,
                    "wccrFormatted": "491.58",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 110.36525508753001,
                    "shockedWccrFormatted": "110.37",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 5(T)",
                        "name": "AIA Dummy 5(T)",
                        "code": "AIA Dummy 5(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 513.1896,
                    "wccrFormatted": "513.19",
                    "occur": "Q3 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 489.92558641488,
                    "shockedWccrFormatted": "489.93",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 3(T)",
                        "name": "AIA Dummy 3(T)",
                        "code": "AIA Dummy 3(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 757.4897,
                    "wccrFormatted": "757.49",
                    "occur": "Q4 2028",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 3923.5400842386102,
                    "shockedWccrFormatted": "3,923.54",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par L)",
                        "name": "HK (Par L)",
                        "code": "HK (Par L)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 905.0187,
                    "wccrFormatted": "905.02",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 5.5983922820967,
                    "shockedWccrFormatted": "5.60",
                    "shockedCashSF": 21439345823.151092,
                    "shockedCashSFFormatted": "21,439.35 M USD",
                    "shockedTreasurySF": 19258063363.21792,
                    "shockedTreasurySFFormatted": "19,258.06 M USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - KOREA (AL)",
                        "name": "Korea (AL)",
                        "code": "KOREA (AL)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 1022.9034,
                    "wccrFormatted": "1,022.90",
                    "occur": "Q2 2022",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 1249.5416620465798,
                    "shockedWccrFormatted": "1,249.54",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 2(T)",
                        "name": "AIA Dummy 2(T)",
                        "code": "AIA Dummy 2(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "wccr": 1069.6432,
                    "wccrFormatted": "1,069.64",
                    "occur": "Q4 2028",
                    "cashSF": 0,
                    "cashSFFormatted": "0.0 USD",
                    "treasurySF": 0,
                    "treasurySFFormatted": "0.0 USD",
                    "shockedWccr": 1278.69683415168,
                    "shockedWccrFormatted": "1,278.70",
                    "shockedCashSF": 0,
                    "shockedCashSFFormatted": "0.0 USD",
                    "shockedTreasurySF": 0,
                    "shockedTreasurySFFormatted": "0.0 USD"
                }
            ],
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        };
    }

    private getFakeFxRateData() {
        return [{
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": [
                {
                    "currency": "GBP",
                    "fxRate": "0.7275",
                    "effectiveDate": null
                },
                {
                    "currency": "TWD",
                    "fxRate": "28.4411",
                    "effectiveDate": null
                },
                {
                    "currency": "HKD",
                    "fxRate": "7.929635",
                    "effectiveDate": null
                },
                {
                    "currency": "EUR",
                    "fxRate": "0.900739",
                    "effectiveDate": null
                },
                {
                    "currency": "CNY",
                    "fxRate": "6.571",
                    "effectiveDate": null
                },
                {
                    "currency": "JPY",
                    "fxRate": "121.6156",
                    "effectiveDate": null
                },
                {
                    "currency": "NZD",
                    "fxRate": "1.442669",
                    "effectiveDate": null
                },
                {
                    "currency": "AUD",
                    "fxRate": "1.336381",
                    "effectiveDate": null
                },
                {
                    "currency": "THB",
                    "fxRate": "33.2504",
                    "effectiveDate": null
                },
                {
                    "currency": "KRW",
                    "fxRate": "1211.129",
                    "effectiveDate": null
                },
                {
                    "currency": "PHP",
                    "fxRate": "51.74569",
                    "effectiveDate": null
                },
                {
                    "currency": "MYR",
                    "fxRate": "4.214017",
                    "effectiveDate": null
                },
                {
                    "currency": "IDR",
                    "fxRate": "14605.0",
                    "effectiveDate": null
                },
                {
                    "currency": "USD",
                    "fxRate": "1.0",
                    "effectiveDate": null
                },
                {
                    "currency": "SGD",
                    "fxRate": "1.3539",
                    "effectiveDate": null
                }
            ],
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        }];
    }

    private getFakeAampProductData() {
        return [{
            "aampProductInfoList": [
                {
                    "productName": "FX Forward",
                    "usedQuota": 59134979,
                    "usedQuotaInMillion": 59.13,
                    "formattedUsedQuota": "59.13 M USD",
                    "numberOfInstruments": 14,
                    "averageMaturityLength": "3 months",
                    "occur": "Q2 2022"
                },
                {
                    "productName": "CCS",
                    "usedQuota": 22300000,
                    "usedQuotaInMillion": 22.3,
                    "formattedUsedQuota": "22.30 M USD",
                    "numberOfInstruments": 7,
                    "averageMaturityLength": "8 years 6 months",
                    "occur": "Q3 2030"
                }
            ],
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        }];
    }

    private getFakeAampQuotasData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": [{
                "rowKey": "26617825-f5a4-4b2b-8a80-b267c7061f29",
                "entityId": "E46",
                "maxQuota": 10,
                "productName": "Repo"
            }],
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        };
    }

    private getFakeDerivativeHoldingsData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": [
                {
                    "productName": "FX Forward",
                    "usedQuota": 59134979,
                    "usedQuotaInMillion": 59.13,
                    "formattedUsedQuota": "59.13",
                    "maxQuota": 0,
                    "maxQuotaInMillion": 0,
                    "usedPercentage": 92233720368547760,
                    "formattedUnused": "-59.13",
                    "unusedPercentage": -92233720368547760
                },
                {
                    "productName": "CCS",
                    "usedQuota": 22300000,
                    "usedQuotaInMillion": 22.3,
                    "formattedUsedQuota": "22.30",
                    "maxQuota": 0,
                    "maxQuotaInMillion": 0,
                    "usedPercentage": 92233720368547760,
                    "formattedUnused": "-22.30",
                    "unusedPercentage": -92233720368547760
                }
            ],
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        };
    }

    private getFakeWccrSummaryData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": {
                "legalEntityAndCounterPartyWCCRList": [
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Australia",
                            "name": "Australia",
                            "code": "AUS",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Australia",
                        "counterParty": "ALL",
                        "swapNotional": 111495148,
                        "swapNotionalFormatted": "111.50 M",
                        "colMV": 1474613000,
                        "colMVFormatted": "1,474.61 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -297747,
                        "swapMTMFormatted": "-297.75 k",
                        "wccr": 6393.9546,
                        "wccrFormatted": "6,393.95",
                        "impColVal": 1306360700,
                        "impColValFormatted": "1,306.36 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -20431186,
                        "impSwapMtmFormatted": "-20.43 M",
                        "impTiming": "2023-03-31"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA CO LTD - SF",
                            "name": "SF",
                            "code": "SF",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA CO LTD - SF",
                        "counterParty": "ALL",
                        "swapNotional": 0,
                        "swapNotionalFormatted": "0.0",
                        "colMV": 174125730,
                        "colMVFormatted": "174.13 M",
                        "repoNotional": 145006770,
                        "repoNotionalFormatted": "145.01 M",
                        "swapMTM": 0,
                        "swapMTMFormatted": "0.0",
                        "wccr": 6235.6094,
                        "wccrFormatted": "6,235.61",
                        "impColVal": 164738560,
                        "impColValFormatted": "164.74 M",
                        "impRepoExp": -2641900,
                        "impRepoExpFormatted": "-2.64 M",
                        "impSwapMtm": 0,
                        "impSwapMtmFormatted": "0.0",
                        "impTiming": "2022-04-14"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Dummy 1(T)",
                            "name": "AIA Dummy 1(T)",
                            "code": "AIA Dummy 1(T)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Dummy 1(T)",
                        "counterParty": "ALL",
                        "swapNotional": 81434979,
                        "swapNotionalFormatted": "81.43 M",
                        "colMV": 577810750,
                        "colMVFormatted": "577.81 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -302363,
                        "swapMTMFormatted": "-302.36 k",
                        "wccr": 2618.7974,
                        "wccrFormatted": "2,618.80",
                        "impColVal": 249297800,
                        "impColValFormatted": "249.30 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -9519553,
                        "impSwapMtmFormatted": "-9.52 M",
                        "impTiming": "2028-09-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Dummy 2(T)",
                            "name": "AIA Dummy 2(T)",
                            "code": "AIA Dummy 2(T)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Dummy 2(T)",
                        "counterParty": "ALL",
                        "swapNotional": 72530424,
                        "swapNotionalFormatted": "72.53 M",
                        "colMV": 275199230,
                        "colMVFormatted": "275.20 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -730493,
                        "swapMTMFormatted": "-730.49 k",
                        "wccr": 1069.6432,
                        "wccrFormatted": "1,069.64",
                        "impColVal": 128850900,
                        "impColValFormatted": "128.85 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -12046157,
                        "impSwapMtmFormatted": "-12.05 M",
                        "impTiming": "2028-12-31"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Dummy 3(T)",
                            "name": "AIA Dummy 3(T)",
                            "code": "AIA Dummy 3(T)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Dummy 3(T)",
                        "counterParty": "ALL",
                        "swapNotional": 47138481,
                        "swapNotionalFormatted": "47.14 M",
                        "colMV": 216994380,
                        "colMVFormatted": "216.99 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -143135,
                        "swapMTMFormatted": "-143.13 k",
                        "wccr": 757.4897,
                        "wccrFormatted": "757.49",
                        "impColVal": 87439590,
                        "impColValFormatted": "87.44 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -11543338,
                        "impSwapMtmFormatted": "-11.54 M",
                        "impTiming": "2028-12-31"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Dummy 4(T)",
                            "name": "AIA Dummy 4(T)",
                            "code": "AIA Dummy 4(T)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Dummy 4(T)",
                        "counterParty": "ALL",
                        "swapNotional": 9824997,
                        "swapNotionalFormatted": "9.82 M",
                        "colMV": 79511730,
                        "colMVFormatted": "79.51 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": 102586,
                        "swapMTMFormatted": "102.59 k",
                        "wccr": 3049.1794,
                        "wccrFormatted": "3,049.18",
                        "impColVal": 26872602,
                        "impColValFormatted": "26.87 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -881306,
                        "impSwapMtmFormatted": "-881.31 k",
                        "impTiming": "2029-09-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Dummy 5(T)",
                            "name": "AIA Dummy 5(T)",
                            "code": "AIA Dummy 5(T)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Dummy 5(T)",
                        "counterParty": "ALL",
                        "swapNotional": 3499997,
                        "swapNotionalFormatted": "3.50 M",
                        "colMV": 997152.2,
                        "colMVFormatted": "997.15 k",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": 10179,
                        "swapMTMFormatted": "10.18 k",
                        "wccr": 513.1896,
                        "wccrFormatted": "513.19",
                        "impColVal": 838654.44,
                        "impColValFormatted": "838.65 k",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -163420,
                        "impSwapMtmFormatted": "-163.42 k",
                        "impTiming": "2022-08-31"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Group",
                        "counterParty": "ALL",
                        "swapNotional": 7826280,
                        "swapNotionalFormatted": "7.83 M",
                        "colMV": 1430121300,
                        "colMVFormatted": "1,430.12 M",
                        "repoNotional": 1000347880,
                        "repoNotionalFormatted": "1,000.35 M",
                        "swapMTM": -463422,
                        "swapMTMFormatted": "-463.42 k",
                        "wccr": 2778.5405,
                        "wccrFormatted": "2,778.54",
                        "impColVal": 1406037500,
                        "impColValFormatted": "1,406.04 M",
                        "impRepoExp": -50299772,
                        "impRepoExpFormatted": "-50.30 M",
                        "impSwapMtm": -303685,
                        "impSwapMtmFormatted": "-303.69 k",
                        "impTiming": "2022-04-07"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA PH (NPar)",
                            "name": "PH (NPar)",
                            "code": "PH (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA PH (NPar)",
                        "counterParty": "ALL",
                        "swapNotional": 80200000,
                        "swapNotionalFormatted": "80.20 M",
                        "colMV": 1275590800,
                        "colMVFormatted": "1,275.59 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": 131801,
                        "swapMTMFormatted": "131.80 k",
                        "wccr": 16154.467,
                        "wccrFormatted": "16,154.47",
                        "impColVal": 1191510500,
                        "impColValFormatted": "1,191.51 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -7375734,
                        "impSwapMtmFormatted": "-7.38 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "DBS",
                        "swapNotional": 143100000,
                        "swapNotionalFormatted": "143.10 M",
                        "colMV": 332026530,
                        "colMVFormatted": "332.03 M",
                        "repoNotional": 52044562,
                        "repoNotionalFormatted": "52.04 M",
                        "swapMTM": 1023922,
                        "swapMTMFormatted": "1.02 M",
                        "wccr": 3283.8057,
                        "wccrFormatted": "3,283.81",
                        "impColVal": 297057250,
                        "impColValFormatted": "297.06 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -9046127,
                        "impSwapMtmFormatted": "-9.05 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "NDBS",
                        "swapNotional": 397143348,
                        "swapNotionalFormatted": "397.14 M",
                        "colMV": 1316253400,
                        "colMVFormatted": "1,316.25 M",
                        "repoNotional": 58422448,
                        "repoNotionalFormatted": "58.42 M",
                        "swapMTM": -1599465,
                        "swapMTMFormatted": "-1.60 M",
                        "wccr": 6028.203,
                        "wccrFormatted": "6,028.20",
                        "impColVal": 1193428400,
                        "impColValFormatted": "1,193.43 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -19797414,
                        "impSwapMtmFormatted": "-19.80 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "DBS",
                        "swapNotional": 626632626,
                        "swapNotionalFormatted": "626.63 M",
                        "colMV": 1598300400,
                        "colMVFormatted": "1,598.30 M",
                        "repoNotional": 268923806,
                        "repoNotionalFormatted": "268.92 M",
                        "swapMTM": -10679785,
                        "swapMTMFormatted": "-10.68 M",
                        "wccr": 2823.223,
                        "wccrFormatted": "2,823.22",
                        "impColVal": 1471777900,
                        "impColValFormatted": "1,471.78 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -52131130,
                        "impSwapMtmFormatted": "-52.13 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "NDBS",
                        "swapNotional": 2651388513,
                        "swapNotionalFormatted": "2,651.39 M",
                        "colMV": 2514926000,
                        "colMVFormatted": "2,514.93 M",
                        "repoNotional": 25712130,
                        "repoNotionalFormatted": "25.71 M",
                        "swapMTM": 7213828,
                        "swapMTMFormatted": "7.21 M",
                        "wccr": 1609.1947,
                        "wccrFormatted": "1,609.19",
                        "impColVal": 2385742300,
                        "impColValFormatted": "2,385.74 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -148256910,
                        "impSwapMtmFormatted": "-148.26 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "ALL",
                        "swapNotional": 6301338828,
                        "swapNotionalFormatted": "6,301.34 M",
                        "colMV": 1952072600,
                        "colMVFormatted": "1,952.07 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -208026050,
                        "swapMTMFormatted": "-208.03 M",
                        "wccr": 424.7691,
                        "wccrFormatted": "424.77",
                        "impColVal": 1802319500,
                        "impColValFormatted": "1,802.32 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -424305700,
                        "impSwapMtmFormatted": "-424.31 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (NPar)",
                            "name": "HK (NPar)",
                            "code": "HK (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (NPar)",
                        "counterParty": "ALL",
                        "swapNotional": 32071126261,
                        "swapNotionalFormatted": "32,071.13 M",
                        "colMV": 25375328000,
                        "colMVFormatted": "25,375.33 M",
                        "repoNotional": 618524721,
                        "repoNotionalFormatted": "618.52 M",
                        "swapMTM": -1959044900,
                        "swapMTMFormatted": "-1,959.04 M",
                        "wccr": 491.583,
                        "wccrFormatted": "491.58",
                        "impColVal": 23444543000,
                        "impColValFormatted": "23,444.54 M",
                        "impRepoExp": 25910766,
                        "impRepoExpFormatted": "25.91 M",
                        "impSwapMtm": -4795104000,
                        "impSwapMtmFormatted": "-4,795.10 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H)",
                            "name": "HK (Par H)",
                            "code": "HK (Par H)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H)",
                        "counterParty": "ALL",
                        "swapNotional": 4769238166,
                        "swapNotionalFormatted": "4,769.24 M",
                        "colMV": 4376430600,
                        "colMVFormatted": "4,376.43 M",
                        "repoNotional": 309067509,
                        "repoNotionalFormatted": "309.07 M",
                        "swapMTM": -560363970,
                        "swapMTMFormatted": "-560.36 M",
                        "wccr": 302.796,
                        "wccrFormatted": "302.80",
                        "impColVal": 3691084800,
                        "impColValFormatted": "3,691.08 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -1219000600,
                        "impSwapMtmFormatted": "-1,219.00 M",
                        "impTiming": "2022-06-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par L)",
                            "name": "HK (Par L)",
                            "code": "HK (Par L)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par L)",
                        "counterParty": "ALL",
                        "swapNotional": 1108694974,
                        "swapNotionalFormatted": "1,108.69 M",
                        "colMV": 1639387000,
                        "colMVFormatted": "1,639.39 M",
                        "repoNotional": 50033222,
                        "repoNotionalFormatted": "50.03 M",
                        "swapMTM": -21581364,
                        "swapMTMFormatted": "-21.58 M",
                        "wccr": 905.0187,
                        "wccrFormatted": "905.02",
                        "impColVal": 1457150700,
                        "impColValFormatted": "1,457.15 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -161007800,
                        "impSwapMtmFormatted": "-161.01 M",
                        "impTiming": "2022-06-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M)",
                            "name": "HK (Par M)",
                            "code": "HK (Par M)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M)",
                        "counterParty": "ALL",
                        "swapNotional": 17707397545,
                        "swapNotionalFormatted": "17,707.40 M",
                        "colMV": 4328320000,
                        "colMVFormatted": "4,328.32 M",
                        "repoNotional": 36112570,
                        "repoNotionalFormatted": "36.11 M",
                        "swapMTM": -923564350,
                        "swapMTMFormatted": "-923.56 M",
                        "wccr": 156.48927,
                        "wccrFormatted": "156.49",
                        "impColVal": 3953107500,
                        "impColValFormatted": "3,953.11 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -2526120400,
                        "impSwapMtmFormatted": "-2,526.12 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X)",
                            "name": "HK (Par X)",
                            "code": "HK (Par X)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X)",
                        "counterParty": "ALL",
                        "swapNotional": 8485795576,
                        "swapNotionalFormatted": "8,485.80 M",
                        "colMV": 4834089000,
                        "colMVFormatted": "4,834.09 M",
                        "repoNotional": 223311420,
                        "repoNotionalFormatted": "223.31 M",
                        "swapMTM": -453535100,
                        "swapMTMFormatted": "-453.54 M",
                        "wccr": 377.6789,
                        "wccrFormatted": "377.68",
                        "impColVal": 4394669000,
                        "impColValFormatted": "4,394.67 M",
                        "impRepoExp": 25910766,
                        "impRepoExpFormatted": "25.91 M",
                        "impSwapMtm": -1189510100,
                        "impSwapMtmFormatted": "-1,189.51 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HO",
                            "name": "HO",
                            "code": "HO",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HO",
                        "counterParty": "Citigroup",
                        "swapNotional": 0,
                        "swapNotionalFormatted": "0.0",
                        "colMV": 51932610,
                        "colMVFormatted": "51.93 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": 0,
                        "swapMTMFormatted": "0.0",
                        "wccr": 0,
                        "wccrFormatted": "0.00",
                        "impColVal": 51932610,
                        "impColValFormatted": "51.93 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": 0,
                        "impSwapMtmFormatted": "0.0",
                        "impTiming": "2022-03-31"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HO",
                            "name": "HO",
                            "code": "HO",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HO",
                        "counterParty": "HSBC",
                        "swapNotional": 0,
                        "swapNotionalFormatted": "0.0",
                        "colMV": 31048434,
                        "colMVFormatted": "31.05 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": 0,
                        "swapMTMFormatted": "0.0",
                        "wccr": 0,
                        "wccrFormatted": "0.00",
                        "impColVal": 31048434,
                        "impColValFormatted": "31.05 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": 0,
                        "impSwapMtmFormatted": "0.0",
                        "impTiming": "2022-03-31"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HO",
                            "name": "HO",
                            "code": "HO",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HO",
                        "counterParty": "BNP Paribas",
                        "swapNotional": 0,
                        "swapNotionalFormatted": "0.0",
                        "colMV": 271056030,
                        "colMVFormatted": "271.06 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": 0,
                        "swapMTMFormatted": "0.0",
                        "wccr": 0,
                        "wccrFormatted": "0.00",
                        "impColVal": 223810700,
                        "impColValFormatted": "223.81 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": 0,
                        "impSwapMtmFormatted": "0.0",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (AL)",
                            "name": "Korea (AL)",
                            "code": "KOREA (AL)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (AL)",
                        "counterParty": "ALL",
                        "swapNotional": 292100000,
                        "swapNotionalFormatted": "292.10 M",
                        "colMV": 476637300,
                        "colMVFormatted": "476.64 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -24901900,
                        "swapMTMFormatted": "-24.90 M",
                        "wccr": 1022.9034,
                        "wccrFormatted": "1,022.90",
                        "impColVal": 433519300,
                        "impColValFormatted": "433.52 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -42381256,
                        "impSwapMtmFormatted": "-42.38 M",
                        "impTiming": "2022-04-30"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (GA)",
                            "name": "Korea (GA)",
                            "code": "KOREA (GA)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (GA)",
                        "counterParty": "ALL",
                        "swapNotional": 791036000,
                        "swapNotionalFormatted": "791.04 M",
                        "colMV": 3459442200,
                        "colMVFormatted": "3,459.44 M",
                        "repoNotional": 0,
                        "repoNotionalFormatted": "0.0",
                        "swapMTM": -77123320,
                        "swapMTMFormatted": "-77.12 M",
                        "wccr": 2210.4358,
                        "wccrFormatted": "2,210.44",
                        "impColVal": 3116691200,
                        "impColValFormatted": "3,116.69 M",
                        "impRepoExp": 0,
                        "impRepoExpFormatted": "0.0",
                        "impSwapMtm": -140998940,
                        "impSwapMtmFormatted": "-141.00 M",
                        "impTiming": "2022-04-30"
                    }
                ],
                "total": {
                    "legalEntity": null,
                    "fund": null,
                    "counterParty": null,
                    "swapNotional": 75758942143,
                    "swapNotionalFormatted": "75,758.94 M",
                    "colMV": 58062214176.2,
                    "colMVFormatted": "58,062.21 M",
                    "repoNotional": 2787507038,
                    "repoNotionalFormatted": "2,787.51 M",
                    "swapMTM": -4233875048,
                    "swapMTMFormatted": "-4,233.88 M",
                    "wccr": 0,
                    "wccrFormatted": "0.00",
                    "impColVal": 52509829400.44,
                    "impColValFormatted": "52,509.83 M",
                    "impRepoExp": -1120140,
                    "impRepoExpFormatted": "-1.12 M",
                    "impSwapMtm": 0,
                    "impSwapMtmFormatted": "0.0",
                    "impTiming": "2022-03-31"
                }
            },
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        };
    }

    private getFakeLastMonthCcrAndEceData() {
        return [{
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": [
                {
                    "counterParty": "ALL",
                    "ccr": 78076.59,
                    "timeStep": 0,
                    "timeStepDate": 1646002800000,
                    "w2Var": 2.21,
                    "peakLiqExp": -0.73,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 19356.55,
                    "timeStep": 0.25,
                    "timeStepDate": 1646607600000,
                    "w2Var": 2.21,
                    "peakLiqExp": -2.9,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 19454.16,
                    "timeStep": 0.5,
                    "timeStepDate": 1647212400000,
                    "w2Var": 2.21,
                    "peakLiqExp": -2.89,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 15865.63,
                    "timeStep": 1,
                    "timeStepDate": 1648418400000,
                    "w2Var": 2.21,
                    "peakLiqExp": -3.53,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 11325.26,
                    "timeStep": 2,
                    "timeStepDate": 1651096800000,
                    "w2Var": 2.21,
                    "peakLiqExp": -4.44,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 9500.29,
                    "timeStep": 3,
                    "timeStepDate": 1653688800000,
                    "w2Var": 2.21,
                    "peakLiqExp": -5.68,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 8535.42,
                    "timeStep": 4,
                    "timeStepDate": 1656367200000,
                    "w2Var": 2.21,
                    "peakLiqExp": -6,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 7305.87,
                    "timeStep": 5,
                    "timeStepDate": 1658959200000,
                    "w2Var": 2.21,
                    "peakLiqExp": -6.73,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 6845.78,
                    "timeStep": 6,
                    "timeStepDate": 1661637600000,
                    "w2Var": 2.21,
                    "peakLiqExp": -7.37,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 9737.85,
                    "timeStep": 9,
                    "timeStepDate": 1669590000000,
                    "w2Var": 2.21,
                    "peakLiqExp": -5.08,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                },
                {
                    "counterParty": "ALL",
                    "ccr": 8809.38,
                    "timeStep": 12,
                    "timeStepDate": 1677538800000,
                    "w2Var": 2.21,
                    "peakLiqExp": -5.75,
                    "occur": "lastMonth",
                    "treasurySf": 0,
                    "treasurySfFormatted": "0.0 USD",
                    "cashSf": 0,
                    "cashSfFormatted": "0.0 USD",
                    "notionalSharePercentage": 0,
                    "notionalInUsd": 0
                }
            ],
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        }];
    }

    private getFakeLowestWccrListData() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": null,
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": [
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par M)",
                        "name": "HK (Par M)",
                        "code": "HK (Par M)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 156.48927,
                    "ccrFormatted": "156.49",
                    "ccrWithPercentageSuffix": "156.489%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 3953107500,
                    "collateralWithSuffix": "3,953.11 M",
                    "fund": "AIAI - HK (Par M)",
                    "notional": 17656922913,
                    "otcMv": -2526120400,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par H)",
                        "name": "HK (Par H)",
                        "code": "HK (Par H)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 302.796,
                    "ccrFormatted": "302.8",
                    "ccrWithPercentageSuffix": "302.796%",
                    "timestepDate": 1656540000000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 3,
                    "collateral": 3691084800,
                    "collateralWithSuffix": "3,691.08 M",
                    "fund": "AIAI - HK (Par H)",
                    "notional": 4491009752,
                    "otcMv": -1219000600,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par X)",
                        "name": "HK (Par X)",
                        "code": "HK (Par X)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 377.6789,
                    "ccrFormatted": "377.68",
                    "ccrWithPercentageSuffix": "377.679%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 4394669000,
                    "collateralWithSuffix": "4,394.67 M",
                    "fund": "AIAI - HK (Par X)",
                    "notional": 8411606460,
                    "otcMv": -1189510100,
                    "repoNotional": 132085235,
                    "repoNotionalWithSuffix": "132.09 M",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Thailand",
                        "name": "Thailand",
                        "code": "THAI",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 424.7691,
                    "ccrFormatted": "424.77",
                    "ccrWithPercentageSuffix": "424.769%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 1802319500,
                    "collateralWithSuffix": "1,802.32 M",
                    "fund": "AIA Thailand",
                    "notional": 6194679760,
                    "otcMv": -424305700,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (NPar)",
                        "name": "HK (NPar)",
                        "code": "HK (NPar)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 491.583,
                    "ccrFormatted": "491.58",
                    "ccrWithPercentageSuffix": "491.583%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 23444543000,
                    "collateralWithSuffix": "23,444.54 M",
                    "fund": "AIAI - HK (NPar)",
                    "notional": 31902782543,
                    "otcMv": -4795104000,
                    "repoNotional": 132085235,
                    "repoNotionalWithSuffix": "132.09 M",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 5(T)",
                        "name": "AIA Dummy 5(T)",
                        "code": "AIA Dummy 5(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 513.1896,
                    "ccrFormatted": "513.19",
                    "ccrWithPercentageSuffix": "513.19%",
                    "timestepDate": 1661896800000,
                    "timestepQuarterYear": "Q3 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 5,
                    "collateral": 838654.44,
                    "collateralWithSuffix": "838.65 k",
                    "fund": "AIA Dummy 5(T)",
                    "notional": 999998,
                    "otcMv": -163420,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 3(T)",
                        "name": "AIA Dummy 3(T)",
                        "code": "AIA Dummy 3(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 757.4897,
                    "ccrFormatted": "757.49",
                    "ccrWithPercentageSuffix": "757.49%",
                    "timestepDate": 1861830000000,
                    "timestepQuarterYear": "Q4 2028",
                    "confidenceLevel": "0.005",
                    "timestep": 81,
                    "collateral": 87439590,
                    "collateralWithSuffix": "87.44 M",
                    "fund": "AIA Dummy 3(T)",
                    "notional": 20500000,
                    "otcMv": -11543338,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HK (Par L)",
                        "name": "HK (Par L)",
                        "code": "HK (Par L)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 905.0187,
                    "ccrFormatted": "905.02",
                    "ccrWithPercentageSuffix": "905.019%",
                    "timestepDate": 1656540000000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 3,
                    "collateral": 1457150700,
                    "collateralWithSuffix": "1,457.15 M",
                    "fund": "AIAI - HK (Par L)",
                    "notional": 1108694974,
                    "otcMv": -161007800,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - KOREA (AL)",
                        "name": "Korea (AL)",
                        "code": "KOREA (AL)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 1022.9034,
                    "ccrFormatted": "1022.9",
                    "ccrWithPercentageSuffix": "1,022.903%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 433519300,
                    "collateralWithSuffix": "433.52 M",
                    "fund": "AIAI - KOREA (AL)",
                    "notional": 292100000,
                    "otcMv": -42381256,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 2(T)",
                        "name": "AIA Dummy 2(T)",
                        "code": "AIA Dummy 2(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 1069.6432,
                    "ccrFormatted": "1069.64",
                    "ccrWithPercentageSuffix": "1,069.643%",
                    "timestepDate": 1861830000000,
                    "timestepQuarterYear": "Q4 2028",
                    "confidenceLevel": "0.005",
                    "timestep": 81,
                    "collateral": 128850900,
                    "collateralWithSuffix": "128.85 M",
                    "fund": "AIA Dummy 2(T)",
                    "notional": 19000000,
                    "otcMv": -12046157,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Singapore (Par)",
                        "name": "Singapore (Par)",
                        "code": "SG (Par)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "NDBS",
                    "ccr": 1609.1947,
                    "ccrFormatted": "1609.19",
                    "ccrWithPercentageSuffix": "1,609.195%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 2385742300,
                    "collateralWithSuffix": "2,385.74 M",
                    "fund": "AIA Singapore (Par)",
                    "notional": 2607428513,
                    "otcMv": -148256910,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - KOREA (GA)",
                        "name": "Korea (GA)",
                        "code": "KOREA (GA)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 2210.4358,
                    "ccrFormatted": "2210.44",
                    "ccrWithPercentageSuffix": "2,210.436%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 3116691200,
                    "collateralWithSuffix": "3,116.69 M",
                    "fund": "AIAI - KOREA (GA)",
                    "notional": 721036000,
                    "otcMv": -140998940,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 1(T)",
                        "name": "AIA Dummy 1(T)",
                        "code": "AIA Dummy 1(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 2618.7974,
                    "ccrFormatted": "2618.8",
                    "ccrWithPercentageSuffix": "2,618.797%",
                    "timestepDate": 1853877600000,
                    "timestepQuarterYear": "Q3 2028",
                    "confidenceLevel": "0.005",
                    "timestep": 78,
                    "collateral": 249297800,
                    "collateralWithSuffix": "249.30 M",
                    "fund": "AIA Dummy 1(T)",
                    "notional": 14400000,
                    "otcMv": -9519553,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Group",
                        "name": "Group",
                        "code": "GROUP",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 2778.5405,
                    "ccrFormatted": "2778.54",
                    "ccrWithPercentageSuffix": "2,778.541%",
                    "timestepDate": 1649282400000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 0.25,
                    "collateral": 1406037500,
                    "collateralWithSuffix": "1,406.04 M",
                    "fund": "AIA Group",
                    "notional": 7826280,
                    "otcMv": -303685,
                    "repoNotional": 1000347880,
                    "repoNotionalWithSuffix": "1,000.35 M",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Singapore (Par)",
                        "name": "Singapore (Par)",
                        "code": "SG (Par)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "DBS",
                    "ccr": 2823.223,
                    "ccrFormatted": "2823.22",
                    "ccrWithPercentageSuffix": "2,823.223%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 1471777900,
                    "collateralWithSuffix": "1,471.78 M",
                    "fund": "AIA Singapore (Par)",
                    "notional": 624382626,
                    "otcMv": -52131130,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Dummy 4(T)",
                        "name": "AIA Dummy 4(T)",
                        "code": "AIA Dummy 4(T)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 3049.1794,
                    "ccrFormatted": "3049.18",
                    "ccrWithPercentageSuffix": "3,049.179%",
                    "timestepDate": 1885413600000,
                    "timestepQuarterYear": "Q3 2029",
                    "confidenceLevel": "0.005",
                    "timestep": 90,
                    "collateral": 26872602,
                    "collateralWithSuffix": "26.87 M",
                    "fund": "AIA Dummy 4(T)",
                    "notional": 1725000,
                    "otcMv": -881306,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Singapore (NPar)",
                        "name": "Singapore (NPar)",
                        "code": "SG (NPar)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "DBS",
                    "ccr": 3283.8057,
                    "ccrFormatted": "3283.81",
                    "ccrWithPercentageSuffix": "3,283.806%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 297057250,
                    "collateralWithSuffix": "297.06 M",
                    "fund": "AIA Singapore (NPar)",
                    "notional": 142350000,
                    "otcMv": -9046127,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Singapore (NPar)",
                        "name": "Singapore (NPar)",
                        "code": "SG (NPar)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "NDBS",
                    "ccr": 6028.203,
                    "ccrFormatted": "6028.2",
                    "ccrWithPercentageSuffix": "6,028.203%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 1193428400,
                    "collateralWithSuffix": "1,193.43 M",
                    "fund": "AIA Singapore (NPar)",
                    "notional": 337223348,
                    "otcMv": -19797414,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA CO LTD - SF",
                        "name": "SF",
                        "code": "SF",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 6235.6094,
                    "ccrFormatted": "6235.61",
                    "ccrWithPercentageSuffix": "6,235.609%",
                    "timestepDate": 1649887200000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 0.5,
                    "collateral": 164738560,
                    "collateralWithSuffix": "164.74 M",
                    "fund": "AIA CO LTD - SF",
                    "notional": 0,
                    "otcMv": 0,
                    "repoNotional": 145006770,
                    "repoNotionalWithSuffix": "145.01 M",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA Australia",
                        "name": "Australia",
                        "code": "AUS",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 6393.9546,
                    "ccrFormatted": "6393.95",
                    "ccrWithPercentageSuffix": "6,393.955%",
                    "timestepDate": 1680213600000,
                    "timestepQuarterYear": "Q1 2023",
                    "confidenceLevel": "0.005",
                    "timestep": 12,
                    "collateral": 1306360700,
                    "collateralWithSuffix": "1,306.36 M",
                    "fund": "AIA Australia",
                    "notional": 111495148,
                    "otcMv": -20431186,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIA PH (NPar)",
                        "name": "PH (NPar)",
                        "code": "PH (NPar)",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "ALL",
                    "ccr": 16154.467,
                    "ccrFormatted": "16154.47",
                    "ccrWithPercentageSuffix": "16,154.467%",
                    "timestepDate": 1651269600000,
                    "timestepQuarterYear": "Q2 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 1,
                    "collateral": 1191510500,
                    "collateralWithSuffix": "1,191.51 M",
                    "fund": "AIA PH (NPar)",
                    "notional": 80200000,
                    "otcMv": -7375734,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HO",
                        "name": "HO",
                        "code": "HO",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "BNP Paribas",
                    "ccr": 1000000000000,
                    "ccrFormatted": "1000 B",
                    "ccrWithPercentageSuffix": "1,000,000,000,000%",
                    "timestepDate": 1648677600000,
                    "timestepQuarterYear": "Q1 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 0,
                    "collateral": 271056030,
                    "collateralWithSuffix": "271.06 M",
                    "fund": "AIAI - HO",
                    "notional": 0,
                    "otcMv": 0,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HO",
                        "name": "HO",
                        "code": "HO",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "Citigroup",
                    "ccr": 1000000000000,
                    "ccrFormatted": "1000 B",
                    "ccrWithPercentageSuffix": "1,000,000,000,000%",
                    "timestepDate": 1648677600000,
                    "timestepQuarterYear": "Q1 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 0,
                    "collateral": 51932610,
                    "collateralWithSuffix": "51.93 M",
                    "fund": "AIAI - HO",
                    "notional": 0,
                    "otcMv": 0,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                },
                {
                    "legalEntity": {
                        "rowKey": null,
                        "entityId": null,
                        "dataName": "AIAI - HO",
                        "name": "HO",
                        "code": "HO",
                        "counterParties": null,
                        "ccrOrExpo": 0
                    },
                    "counterParty": "HSBC",
                    "ccr": 1000000000000,
                    "ccrFormatted": "1000 B",
                    "ccrWithPercentageSuffix": "1,000,000,000,000%",
                    "timestepDate": 1648677600000,
                    "timestepQuarterYear": "Q1 2022",
                    "confidenceLevel": "0.005",
                    "timestep": 0,
                    "collateral": 31048434,
                    "collateralWithSuffix": "31.05 M",
                    "fund": "AIAI - HO",
                    "notional": 0,
                    "otcMv": 0,
                    "repoNotional": 0,
                    "repoNotionalWithSuffix": "0.0",
                    "csa": true
                }
            ],
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "simuProductNotional": null
        }
    }



    /**
     * Fetch the notification data from a fake backend (json-server)
     *
     * Warning: all HTTP errors are ignored here!
     *
     * @todo better error handling
     * @returns {Observable<SimulationNotification[]>}
     * @memberof DataService
     */
    getNotifications(user: string): Observable<SimulationNotification[]> {
        //return this.http.get<any>(BASE_URL + 'notifications/' + user, this.getAuthTokenHeader())
        return this.http.get<any>(BASE_URL + 'notifications/notifs').pipe(
            catchError(err => of(null)),
            filter(obj => !isNil(obj)),
            filter(obj => !isNil(obj.notifs)),
            map(obj => obj.notifs),
            map((list: SimulationNotification[]) => list.filter((notif: SimulationNotification) => notif.isVisible)));
    }

    /**
     * Update one or several simulation notification
     *
     * Warning: all HTTP errors are ignored here!
     *
     * @param {SimulationNotificationUpdate} notifs
     * @returns {Observable<SimulationNotificationUpdate>}
     * @memberof DataService
     */
    updateNotifications(notifs: SimulationNotificationUpdate): Observable<SimulationNotificationUpdate> {
        return this.http.post<SimulationNotificationUpdate>(BASE_URL + `notifications`, notifs).pipe(
            catchError(err => of(null)),
            filter(item => item !== null));
    }


    deleteTradeNotifications(modelId: string): Observable<boolean> {
        return this.http.get<boolean>(BASE_URL + `notifications/delete/` + modelId);
    }

    /**
     * Run a script in the backend in order to update projections.
     *
     * @param {string} modelId
     * @param {UpdateProjectionsRequest} req
     * @returns {Observable<any>}
     * @memberof DataService
     */
    updateProjections(modelId: string, req: UpdateProjectionsRequest): Observable<any> {
        return this.http.post<any>(BASE_URL + `updateProjections/${modelId}`, req);
    }

    /**
     * Run a script in the backend in order to run the invoicing aggregation script.
     *
     * @param {any} req
     * @returns {Observable<any>}
     * @memberof DataService
     */
    runInvoicesAggregation(req: any): Observable<any> {
        console.log("In runInvoiceAggregation");
        return this.http.post<any>(BASE_URL + `updateInvoices`, req);
    }

    /**
     * Get the path of the last imported CSV files.
     *
     * @returns {Observable<any>}
     * @memberof DataService
     */
    getLatestOtcFiles(): Observable<any> {
        return this.http.get<any>(BASE_URL + 'latestOtcFiles');
    }

    /**
     * Get the content of the requested OTC_EIO csv file.
     *
     * @param {string} csvPath
     * @returns {Observable<any>}
     * @memberof DataService
     */
    getOtcEio(csvPath: string): Observable<any> {
        return this.http.post<any>(BASE_URL + `otcEio`, csvPath)
    }

    /**
     * Get the content of the requested DTO_FXO csv file.
     *
     * @param {string} csvPath
     * @returns {Observable<any>}
     * @memberof DataService
     */
    getOtcFxo(csvPath: string): Observable<any> {
        return this.http.post<any>(BASE_URL + `otcFxo`, csvPath)
    }

    /**
     * Logout to SSO login page.
     *
     * @param
     * @returns
     * @memberof DataService
     */
    logOutUser() {
        this.clearCacheData();
        this._router.navigateByUrl("/logout");
    }


    private getFakeDerivativeExposure() {
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": {
                "derivativeExposures": [
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Australia",
                            "name": "Australia",
                            "code": "AUS",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Australia",
                        "counterParty": "ANZ",
                        "payNotional": 4.7972763E7,
                        "payNotionalFormatted": "47.97 M",
                        "netMTM": 7362044.0,
                        "netMTMFormatted": "7.36 M",
                        "w2Var": 1494003.0,
                        "w2VarFormatted": "1.49 M",
                        "peakCE": 2.1174856E7,
                        "peakCEFormatted": "21.17 M",
                        "threshold": 0,
                        "totCE": 1994003.0,
                        "totCEFormatted": "1.99 M",
                        "expNot": 4.156531488503174,
                        "expNotFormatted": "4.16",
                        "peakLiqExp": -2.425986E7,
                        "peakLiqExpFormatted": "-24.26 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Australia",
                            "name": "Australia",
                            "code": "AUS",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Australia",
                        "counterParty": "Citigroup",
                        "payNotional": 6.7316619E7,
                        "payNotionalFormatted": "67.32 M",
                        "netMTM": 8316465.0,
                        "netMTMFormatted": "8.32 M",
                        "w2Var": 2035421.0,
                        "w2VarFormatted": "2.04 M",
                        "peakCE": 2.8577606E7,
                        "peakCEFormatted": "28.58 M",
                        "threshold": 0,
                        "totCE": 2535421.0,
                        "totCEFormatted": "2.54 M",
                        "expNot": 3.7664116791129985,
                        "expNotFormatted": "3.77",
                        "peakLiqExp": -3.6072296E7,
                        "peakLiqExpFormatted": "-36.07 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA CO LTD - SF",
                            "name": "SF",
                            "code": "SF",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA CO LTD - SF",
                        "counterParty": "ANZ",
                        "payNotional": 5.4930779E7,
                        "payNotionalFormatted": "54.93 M",
                        "netMTM": -982972.0,
                        "netMTMFormatted": "-982.97 k",
                        "w2Var": 1213919.0,
                        "w2VarFormatted": "1.21 M",
                        "peakCE": 3770721.0,
                        "peakCEFormatted": "3.77 M",
                        "threshold": 0,
                        "totCE": 1213919.0,
                        "totCEFormatted": "1.21 M",
                        "expNot": 2.209906762836915,
                        "expNotFormatted": "2.21",
                        "peakLiqExp": -6165860.0,
                        "peakLiqExpFormatted": "-6.17 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA CO LTD - SF",
                            "name": "SF",
                            "code": "SF",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA CO LTD - SF",
                        "counterParty": "HSBC",
                        "payNotional": 1.10604093E8,
                        "payNotionalFormatted": "110.60 M",
                        "netMTM": -1966053.0,
                        "netMTMFormatted": "-1.97 M",
                        "w2Var": 2442612.0,
                        "w2VarFormatted": "2.44 M",
                        "peakCE": 8756295.0,
                        "peakCEFormatted": "8.76 M",
                        "threshold": 0,
                        "totCE": 2442612.0,
                        "totCEFormatted": "2.44 M",
                        "expNot": 2.2084282179322243,
                        "expNotFormatted": "2.21",
                        "peakLiqExp": -1.3859043E7,
                        "peakLiqExpFormatted": "-13.86 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA CO LTD - SF",
                            "name": "SF",
                            "code": "SF",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA CO LTD - SF",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 1.09894495E8,
                        "payNotionalFormatted": "109.89 M",
                        "netMTM": -1944804.0,
                        "netMTMFormatted": "-1.94 M",
                        "w2Var": 2399954.0,
                        "w2VarFormatted": "2.40 M",
                        "peakCE": 4166248.0,
                        "peakCEFormatted": "4.17 M",
                        "threshold": 0,
                        "totCE": 2399954.0,
                        "totCEFormatted": "2.40 M",
                        "expNot": 2.1838709937199314,
                        "expNotFormatted": "2.18",
                        "peakLiqExp": -9261049.0,
                        "peakLiqExpFormatted": "-9.26 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA CO LTD - SF",
                            "name": "SF",
                            "code": "SF",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA CO LTD - SF",
                        "counterParty": "Standard Chartered",
                        "payNotional": 5.4957296E7,
                        "payNotionalFormatted": "54.96 M",
                        "netMTM": -969251.0,
                        "netMTMFormatted": "-969.25 k",
                        "w2Var": 1187015.0,
                        "w2VarFormatted": "1.19 M",
                        "peakCE": 1337795.0,
                        "peakCEFormatted": "1.34 M",
                        "threshold": 0,
                        "totCE": 1187015.0,
                        "totCEFormatted": "1.19 M",
                        "expNot": 2.159886105022343,
                        "expNotFormatted": "2.16",
                        "peakLiqExp": -3511286.0,
                        "peakLiqExpFormatted": "-3.51 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Group",
                        "counterParty": "CACIB",
                        "payNotional": 7.1992511E7,
                        "payNotionalFormatted": "71.99 M",
                        "netMTM": -1557722.0,
                        "netMTMFormatted": "-1.56 M",
                        "w2Var": 2794990.0,
                        "w2VarFormatted": "2.79 M",
                        "peakCE": 9553913.0,
                        "peakCEFormatted": "9.55 M",
                        "threshold": 0,
                        "totCE": 2794990.0,
                        "totCEFormatted": "2.79 M",
                        "expNot": 3.882334372251581,
                        "expNotFormatted": "3.88",
                        "peakLiqExp": -1.8255058E7,
                        "peakLiqExpFormatted": "-18.26 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Group",
                        "counterParty": "Goldman Sachs",
                        "payNotional": 1.68516193E8,
                        "payNotionalFormatted": "168.52 M",
                        "netMTM": 750676.0,
                        "netMTMFormatted": "750.68 k",
                        "w2Var": 4245738.0,
                        "w2VarFormatted": "4.25 M",
                        "peakCE": 8752588.0,
                        "peakCEFormatted": "8.75 M",
                        "threshold": 0,
                        "totCE": 4745738.0,
                        "totCEFormatted": "4.75 M",
                        "expNot": 2.8161910825982166,
                        "expNotFormatted": "2.82",
                        "peakLiqExp": -7953212.0,
                        "peakLiqExpFormatted": "-7.95 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Group",
                        "counterParty": "HSBC",
                        "payNotional": 7.30786954E8,
                        "payNotionalFormatted": "730.79 M",
                        "netMTM": -4419975.0,
                        "netMTMFormatted": "-4.42 M",
                        "w2Var": 1510689.0,
                        "w2VarFormatted": "1.51 M",
                        "peakCE": 5725868.0,
                        "peakCEFormatted": "5.73 M",
                        "threshold": 0,
                        "totCE": 1510689.0,
                        "totCEFormatted": "1.51 M",
                        "expNot": 0.20672084958976975,
                        "expNotFormatted": "0.21",
                        "peakLiqExp": -1.0594526E7,
                        "peakLiqExpFormatted": "-10.59 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Group",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 9.8139125E7,
                        "payNotionalFormatted": "98.14 M",
                        "netMTM": 34466.0,
                        "netMTMFormatted": "34.47 k",
                        "w2Var": 0.0,
                        "w2VarFormatted": "0.0",
                        "peakCE": 34466.0,
                        "peakCEFormatted": "34.47 k",
                        "threshold": 0,
                        "totCE": 0.0,
                        "totCEFormatted": "0.0",
                        "expNot": 0.0,
                        "expNotFormatted": "0.00",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Group",
                            "name": "Group",
                            "code": "GROUP",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Group",
                        "counterParty": "Standard Chartered",
                        "payNotional": 1.338728975E9,
                        "payNotionalFormatted": "1,338.73 M",
                        "netMTM": 943641.0,
                        "netMTMFormatted": "943.64 k",
                        "w2Var": 1257094.0,
                        "w2VarFormatted": "1.26 M",
                        "peakCE": 4894944.0,
                        "peakCEFormatted": "4.89 M",
                        "threshold": 0,
                        "totCE": 1757094.0,
                        "totCEFormatted": "1.76 M",
                        "expNot": 0.131250912829462,
                        "expNotFormatted": "0.13",
                        "peakLiqExp": -4297203.0,
                        "peakLiqExpFormatted": "-4.30 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA MY",
                            "name": "MY",
                            "code": "MY",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA MY",
                        "counterParty": "CIMB",
                        "payNotional": 5.0625E7,
                        "payNotionalFormatted": "50.63 M",
                        "netMTM": -1463569.0,
                        "netMTMFormatted": "-1.46 M",
                        "w2Var": 2354679.0,
                        "w2VarFormatted": "2.35 M",
                        "peakCE": 2.7577904E7,
                        "peakCEFormatted": "27.58 M",
                        "threshold": 0,
                        "totCE": 2354679.0,
                        "totCEFormatted": "2.35 M",
                        "expNot": 4.651217777777777,
                        "expNotFormatted": "4.65",
                        "peakLiqExp": -1.6011155E7,
                        "peakLiqExpFormatted": "-16.01 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA MY",
                            "name": "MY",
                            "code": "MY",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA MY",
                        "counterParty": "Standard Chartered",
                        "payNotional": 5.07E7,
                        "payNotionalFormatted": "50.70 M",
                        "netMTM": -502741.0,
                        "netMTMFormatted": "-502.74 k",
                        "w2Var": 1787247.0,
                        "w2VarFormatted": "1.79 M",
                        "peakCE": 1.7628752E7,
                        "peakCEFormatted": "17.63 M",
                        "threshold": 0,
                        "totCE": 1787247.0,
                        "totCEFormatted": "1.79 M",
                        "expNot": 3.5251420118343195,
                        "expNotFormatted": "3.53",
                        "peakLiqExp": -1.3453677E7,
                        "peakLiqExpFormatted": "-13.45 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA PH (NPar)",
                            "name": "PH (NPar)",
                            "code": "PH (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA PH (NPar)",
                        "counterParty": "ING",
                        "payNotional": 1.69E7,
                        "payNotionalFormatted": "16.90 M",
                        "netMTM": 683822.0,
                        "netMTMFormatted": "683.82 k",
                        "w2Var": 689683.0,
                        "w2VarFormatted": "689.68 k",
                        "peakCE": 5879960.0,
                        "peakCEFormatted": "5.88 M",
                        "threshold": 0,
                        "totCE": 1189683.0,
                        "totCEFormatted": "1.19 M",
                        "expNot": 7.039544378698224,
                        "expNotFormatted": "7.04",
                        "peakLiqExp": -3556928.0,
                        "peakLiqExpFormatted": "-3.56 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA PH (NPar)",
                            "name": "PH (NPar)",
                            "code": "PH (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA PH (NPar)",
                        "counterParty": "Metro",
                        "payNotional": 2.6E7,
                        "payNotionalFormatted": "26.00 M",
                        "netMTM": 3960039.0,
                        "netMTMFormatted": "3.96 M",
                        "w2Var": 1170426.0,
                        "w2VarFormatted": "1.17 M",
                        "peakCE": 1.2139546E7,
                        "peakCEFormatted": "12.14 M",
                        "threshold": 0,
                        "totCE": 1670426.0,
                        "totCEFormatted": "1.67 M",
                        "expNot": 6.424715384615384,
                        "expNotFormatted": "6.42",
                        "peakLiqExp": -4175271.0,
                        "peakLiqExpFormatted": "-4.18 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "Citigroup",
                        "payNotional": 7.0960609E7,
                        "payNotionalFormatted": "70.96 M",
                        "netMTM": -410403.0,
                        "netMTMFormatted": "-410.40 k",
                        "w2Var": 1963267.0,
                        "w2VarFormatted": "1.96 M",
                        "peakCE": 2.2552156E7,
                        "peakCEFormatted": "22.55 M",
                        "threshold": 0,
                        "totCE": 1963267.0,
                        "totCEFormatted": "1.96 M",
                        "expNot": 2.766699761553625,
                        "expNotFormatted": "2.77",
                        "peakLiqExp": -1.2009777E7,
                        "peakLiqExpFormatted": "-12.01 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "DBS",
                        "payNotional": 2.0701E8,
                        "payNotionalFormatted": "207.01 M",
                        "netMTM": 4012056.0,
                        "netMTMFormatted": "4.01 M",
                        "w2Var": 5371447.0,
                        "w2VarFormatted": "5.37 M",
                        "peakCE": 3.3461068E7,
                        "peakCEFormatted": "33.46 M",
                        "threshold": 0,
                        "totCE": 5871447.0,
                        "totCEFormatted": "5.87 M",
                        "expNot": 2.8363108062412445,
                        "expNotFormatted": "2.84",
                        "peakLiqExp": -1.5217564E7,
                        "peakLiqExpFormatted": "-15.22 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "HSBC",
                        "payNotional": 2.43016309E8,
                        "payNotionalFormatted": "243.02 M",
                        "netMTM": 7530236.0,
                        "netMTMFormatted": "7.53 M",
                        "w2Var": 4731630.0,
                        "w2VarFormatted": "4.73 M",
                        "peakCE": 3.28671E7,
                        "peakCEFormatted": "32.87 M",
                        "threshold": 0,
                        "totCE": 5231630.0,
                        "totCEFormatted": "5.23 M",
                        "expNot": 2.152789671412547,
                        "expNotFormatted": "2.15",
                        "peakLiqExp": -1.4217848E7,
                        "peakLiqExpFormatted": "-14.22 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "JP Morgan",
                        "payNotional": 4.7305054E7,
                        "payNotionalFormatted": "47.31 M",
                        "netMTM": -131808.0,
                        "netMTMFormatted": "-131.81 k",
                        "w2Var": 1406781.0,
                        "w2VarFormatted": "1.41 M",
                        "peakCE": 1.4070453E7,
                        "peakCEFormatted": "14.07 M",
                        "threshold": 0,
                        "totCE": 1406781.0,
                        "totCEFormatted": "1.41 M",
                        "expNot": 2.9738492635480345,
                        "expNotFormatted": "2.97",
                        "peakLiqExp": -8709078.0,
                        "peakLiqExpFormatted": "-8.71 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "Standard Chartered",
                        "payNotional": 3.24E7,
                        "payNotionalFormatted": "32.40 M",
                        "netMTM": -2524311.0,
                        "netMTMFormatted": "-2.52 M",
                        "w2Var": 787073.0,
                        "w2VarFormatted": "787.07 k",
                        "peakCE": 5811404.0,
                        "peakCEFormatted": "5.81 M",
                        "threshold": 0,
                        "totCE": 787073.0,
                        "totCEFormatted": "787.07 k",
                        "expNot": 2.4292376543209877,
                        "expNotFormatted": "2.43",
                        "peakLiqExp": -6474923.0,
                        "peakLiqExpFormatted": "-6.47 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (NPar)",
                            "name": "Singapore (NPar)",
                            "code": "SG (NPar)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (NPar)",
                        "counterParty": "UOB",
                        "payNotional": 3.38E7,
                        "payNotionalFormatted": "33.80 M",
                        "netMTM": 691691.0,
                        "netMTMFormatted": "691.69 k",
                        "w2Var": 1145891.0,
                        "w2VarFormatted": "1.15 M",
                        "peakCE": 1.4887123E7,
                        "peakCEFormatted": "14.89 M",
                        "threshold": 0,
                        "totCE": 1645891.0,
                        "totCEFormatted": "1.65 M",
                        "expNot": 4.8695,
                        "expNotFormatted": "4.87",
                        "peakLiqExp": -6283257.0,
                        "peakLiqExpFormatted": "-6.28 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "Citigroup",
                        "payNotional": 6.6469599E8,
                        "payNotionalFormatted": "664.70 M",
                        "netMTM": 2.7347896E7,
                        "netMTMFormatted": "27.35 M",
                        "w2Var": 2.0637234E7,
                        "w2VarFormatted": "20.64 M",
                        "peakCE": 2.6562805E8,
                        "peakCEFormatted": "265.63 M",
                        "threshold": 0,
                        "totCE": 2.1137234E7,
                        "totCEFormatted": "21.14 M",
                        "expNot": 3.1799851839033964,
                        "expNotFormatted": "3.18",
                        "peakLiqExp": -9.228189E7,
                        "peakLiqExpFormatted": "-92.28 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "DBS",
                        "payNotional": 7.26175E8,
                        "payNotionalFormatted": "726.17 M",
                        "netMTM": -1972868.0,
                        "netMTMFormatted": "-1.97 M",
                        "w2Var": 2.0551932E7,
                        "w2VarFormatted": "20.55 M",
                        "peakCE": 1.4504254E8,
                        "peakCEFormatted": "145.04 M",
                        "threshold": 0,
                        "totCE": 2.0551932E7,
                        "totCEFormatted": "20.55 M",
                        "expNot": 2.830162426412366,
                        "expNotFormatted": "2.83",
                        "peakLiqExp": -1.0260862E8,
                        "peakLiqExpFormatted": "-102.61 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "HSBC",
                        "payNotional": 7.57521512E8,
                        "payNotionalFormatted": "757.52 M",
                        "netMTM": 91577.0,
                        "netMTMFormatted": "91.58 k",
                        "w2Var": 1.7041283E7,
                        "w2VarFormatted": "17.04 M",
                        "peakCE": 1.253517E8,
                        "peakCEFormatted": "125.35 M",
                        "threshold": 0,
                        "totCE": 1.7541283E7,
                        "totCEFormatted": "17.54 M",
                        "expNot": 2.315615163678679,
                        "expNotFormatted": "2.32",
                        "peakLiqExp": -7.216773E7,
                        "peakLiqExpFormatted": "-72.17 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "JP Morgan",
                        "payNotional": 6.21257184E8,
                        "payNotionalFormatted": "621.26 M",
                        "netMTM": 1302721.0,
                        "netMTMFormatted": "1.30 M",
                        "w2Var": 1.7386173E7,
                        "w2VarFormatted": "17.39 M",
                        "peakCE": 1.536542E8,
                        "peakCEFormatted": "153.65 M",
                        "threshold": 0,
                        "totCE": 1.7886173E7,
                        "totCEFormatted": "17.89 M",
                        "expNot": 2.8790287598509283,
                        "expNotFormatted": "2.88",
                        "peakLiqExp": -8.741443E7,
                        "peakLiqExpFormatted": "-87.41 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "OCBC",
                        "payNotional": 7.7340056E7,
                        "payNotionalFormatted": "77.34 M",
                        "netMTM": 1183547.0,
                        "netMTMFormatted": "1.18 M",
                        "w2Var": 3437346.0,
                        "w2VarFormatted": "3.44 M",
                        "peakCE": 1.0214986E7,
                        "peakCEFormatted": "10.21 M",
                        "threshold": 0,
                        "totCE": 3937346.0,
                        "totCEFormatted": "3.94 M",
                        "expNot": 5.0909531278332665,
                        "expNotFormatted": "5.09",
                        "peakLiqExp": -1.1373996E7,
                        "peakLiqExpFormatted": "-11.37 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "Standard Chartered",
                        "payNotional": 2.028E8,
                        "payNotionalFormatted": "202.80 M",
                        "netMTM": -1.2718659E7,
                        "netMTMFormatted": "-12.72 M",
                        "w2Var": 4858757.0,
                        "w2VarFormatted": "4.86 M",
                        "peakCE": 2.045209E7,
                        "peakCEFormatted": "20.45 M",
                        "threshold": 0,
                        "totCE": 4858757.0,
                        "totCEFormatted": "4.86 M",
                        "expNot": 2.3958367850098616,
                        "expNotFormatted": "2.40",
                        "peakLiqExp": -2.8499724E7,
                        "peakLiqExpFormatted": "-28.50 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Singapore (Par)",
                            "name": "Singapore (Par)",
                            "code": "SG (Par)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Singapore (Par)",
                        "counterParty": "UOB",
                        "payNotional": 1.81038099E8,
                        "payNotionalFormatted": "181.04 M",
                        "netMTM": 1.2229608E7,
                        "netMTMFormatted": "12.23 M",
                        "w2Var": 6408588.0,
                        "w2VarFormatted": "6.41 M",
                        "peakCE": 8.551158E7,
                        "peakCEFormatted": "85.51 M",
                        "threshold": 0,
                        "totCE": 6908588.0,
                        "totCEFormatted": "6.91 M",
                        "expNot": 3.816096190890736,
                        "expNotFormatted": "3.82",
                        "peakLiqExp": -3.0028896E7,
                        "peakLiqExpFormatted": "-30.03 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Taiwan",
                            "name": "Taiwan",
                            "code": "TAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Taiwan",
                        "counterParty": "China Trust",
                        "payNotional": 1.71496117E8,
                        "payNotionalFormatted": "171.50 M",
                        "netMTM": 1.38326E7,
                        "netMTMFormatted": "13.83 M",
                        "w2Var": 2040346.0,
                        "w2VarFormatted": "2.04 M",
                        "peakCE": 1.8113216E7,
                        "peakCEFormatted": "18.11 M",
                        "threshold": 0,
                        "totCE": 1.5872946E7,
                        "totCEFormatted": "15.87 M",
                        "expNot": 9.255571658220111,
                        "expNotFormatted": "9.26",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Taiwan",
                            "name": "Taiwan",
                            "code": "TAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Taiwan",
                        "counterParty": "Citigroup",
                        "payNotional": 1.70128827E8,
                        "payNotionalFormatted": "170.13 M",
                        "netMTM": 1.1249055E7,
                        "netMTMFormatted": "11.25 M",
                        "w2Var": 1949506.0,
                        "w2VarFormatted": "1.95 M",
                        "peakCE": 1.3198561E7,
                        "peakCEFormatted": "13.20 M",
                        "threshold": 0,
                        "totCE": 1.3198561E7,
                        "totCEFormatted": "13.20 M",
                        "expNot": 7.757980368606197,
                        "expNotFormatted": "7.76",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Taiwan",
                            "name": "Taiwan",
                            "code": "TAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Taiwan",
                        "counterParty": "First Commercial",
                        "payNotional": 1.10435315E8,
                        "payNotionalFormatted": "110.44 M",
                        "netMTM": 6899580.0,
                        "netMTMFormatted": "6.90 M",
                        "w2Var": 488918.0,
                        "w2VarFormatted": "488.92 k",
                        "peakCE": 8148205.0,
                        "peakCEFormatted": "8.15 M",
                        "threshold": 0,
                        "totCE": 7388498.0,
                        "totCEFormatted": "7.39 M",
                        "expNot": 6.69033995149106,
                        "expNotFormatted": "6.69",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Taiwan",
                            "name": "Taiwan",
                            "code": "TAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Taiwan",
                        "counterParty": "Taipei Fubon Commercial",
                        "payNotional": 2.05538686E8,
                        "payNotionalFormatted": "205.54 M",
                        "netMTM": 1.9005312E7,
                        "netMTMFormatted": "19.01 M",
                        "w2Var": 2568348.0,
                        "w2VarFormatted": "2.57 M",
                        "peakCE": 2.7943112E7,
                        "peakCEFormatted": "27.94 M",
                        "threshold": 0,
                        "totCE": 2.157366E7,
                        "totCEFormatted": "21.57 M",
                        "expNot": 10.496155453674545,
                        "expNotFormatted": "10.50",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "ANZ",
                        "payNotional": 9000000.0,
                        "payNotionalFormatted": "9.00 M",
                        "netMTM": -208757.0,
                        "netMTMFormatted": "-208.76 k",
                        "w2Var": 286088.0,
                        "w2VarFormatted": "286.09 k",
                        "peakCE": 7036138.0,
                        "peakCEFormatted": "7.04 M",
                        "threshold": 0,
                        "totCE": 286088.0,
                        "totCEFormatted": "286.09 k",
                        "expNot": 3.1787555555555556,
                        "expNotFormatted": "3.18",
                        "peakLiqExp": -2745043.0,
                        "peakLiqExpFormatted": "-2.75 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Ayudhya Public",
                        "payNotional": 6.35719645E8,
                        "payNotionalFormatted": "635.72 M",
                        "netMTM": 2.3083378E7,
                        "netMTMFormatted": "23.08 M",
                        "w2Var": 8229104.0,
                        "w2VarFormatted": "8.23 M",
                        "peakCE": 9.642606E7,
                        "peakCEFormatted": "96.43 M",
                        "threshold": 0,
                        "totCE": 8729104.0,
                        "totCEFormatted": "8.73 M",
                        "expNot": 1.3731059074004233,
                        "expNotFormatted": "1.37",
                        "peakLiqExp": -4.7139748E7,
                        "peakLiqExpFormatted": "-47.14 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "BNP Paribas",
                        "payNotional": 1.118012076E9,
                        "payNotionalFormatted": "1,118.01 M",
                        "netMTM": -8258238.0,
                        "netMTMFormatted": "-8.26 M",
                        "w2Var": 2.3531634E7,
                        "w2VarFormatted": "23.53 M",
                        "peakCE": 3.5674106E8,
                        "peakCEFormatted": "356.74 M",
                        "threshold": 0,
                        "totCE": 2.3531634E7,
                        "totCEFormatted": "23.53 M",
                        "expNot": 2.1047745820591657,
                        "expNotFormatted": "2.10",
                        "peakLiqExp": -2.1436429E8,
                        "peakLiqExpFormatted": "-214.36 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Bangkok Bank",
                        "payNotional": 4.45768987E8,
                        "payNotionalFormatted": "445.77 M",
                        "netMTM": -2.9078664E7,
                        "netMTMFormatted": "-29.08 M",
                        "w2Var": 7747426.0,
                        "w2VarFormatted": "7.75 M",
                        "peakCE": 9.78431E7,
                        "peakCEFormatted": "97.84 M",
                        "threshold": 0,
                        "totCE": 7747426.0,
                        "totCEFormatted": "7.75 M",
                        "expNot": 1.7379912524062604,
                        "expNotFormatted": "1.74",
                        "peakLiqExp": -2.5161848E8,
                        "peakLiqExpFormatted": "-251.62 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "CIMB",
                        "payNotional": 6.71016747E8,
                        "payNotionalFormatted": "671.02 M",
                        "netMTM": -1.0078872E7,
                        "netMTMFormatted": "-10.08 M",
                        "w2Var": 9865299.0,
                        "w2VarFormatted": "9.87 M",
                        "peakCE": 9.777483E7,
                        "peakCEFormatted": "97.77 M",
                        "threshold": 0,
                        "totCE": 9865299.0,
                        "totCEFormatted": "9.87 M",
                        "expNot": 1.4702016073527298,
                        "expNotFormatted": "1.47",
                        "peakLiqExp": -1.0174974E8,
                        "peakLiqExpFormatted": "-101.75 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Citigroup",
                        "payNotional": 5.11160436E8,
                        "payNotionalFormatted": "511.16 M",
                        "netMTM": -6868399.0,
                        "netMTMFormatted": "-6.87 M",
                        "w2Var": 6863311.0,
                        "w2VarFormatted": "6.86 M",
                        "peakCE": 4.6394228E7,
                        "peakCEFormatted": "46.39 M",
                        "threshold": 3000000,
                        "totCE": 6863311.0,
                        "totCEFormatted": "6.86 M",
                        "expNot": 1.3426921405943866,
                        "expNotFormatted": "1.34",
                        "peakLiqExp": -4.104903E7,
                        "peakLiqExpFormatted": "-41.05 M",
                        "thresholdFormatted": "3.00 M"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Deutsche",
                        "payNotional": 3.355E7,
                        "payNotionalFormatted": "33.55 M",
                        "netMTM": -1162790.0,
                        "netMTMFormatted": "-1.16 M",
                        "w2Var": 1340425.0,
                        "w2VarFormatted": "1.34 M",
                        "peakCE": 2.6877608E7,
                        "peakCEFormatted": "26.88 M",
                        "threshold": 0,
                        "totCE": 1340425.0,
                        "totCEFormatted": "1.34 M",
                        "expNot": 3.9953055141579727,
                        "expNotFormatted": "4.00",
                        "peakLiqExp": -1.1151376E7,
                        "peakLiqExpFormatted": "-11.15 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "HSBC",
                        "payNotional": 6.15439294E8,
                        "payNotionalFormatted": "615.44 M",
                        "netMTM": -3317193.0,
                        "netMTMFormatted": "-3.32 M",
                        "w2Var": 1.0569214E7,
                        "w2VarFormatted": "10.57 M",
                        "peakCE": 1.2208454E8,
                        "peakCEFormatted": "122.08 M",
                        "threshold": 0,
                        "totCE": 1.0569214E7,
                        "totCEFormatted": "10.57 M",
                        "expNot": 1.7173446842021107,
                        "expNotFormatted": "1.72",
                        "peakLiqExp": -8.807855E7,
                        "peakLiqExpFormatted": "-88.08 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Kasikornbank",
                        "payNotional": 4.38569349E8,
                        "payNotionalFormatted": "438.57 M",
                        "netMTM": -2895495.0,
                        "netMTMFormatted": "-2.90 M",
                        "w2Var": 5060596.0,
                        "w2VarFormatted": "5.06 M",
                        "peakCE": 4.6279736E7,
                        "peakCEFormatted": "46.28 M",
                        "threshold": 0,
                        "totCE": 5060596.0,
                        "totCEFormatted": "5.06 M",
                        "expNot": 1.153887295484482,
                        "expNotFormatted": "1.15",
                        "peakLiqExp": -6.50726E7,
                        "peakLiqExpFormatted": "-65.07 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Mizuho Bank",
                        "payNotional": 1.66838515E8,
                        "payNotionalFormatted": "166.84 M",
                        "netMTM": -2103717.0,
                        "netMTMFormatted": "-2.10 M",
                        "w2Var": 2383555.0,
                        "w2VarFormatted": "2.38 M",
                        "peakCE": 2.1041172E7,
                        "peakCEFormatted": "21.04 M",
                        "threshold": 0,
                        "totCE": 2383555.0,
                        "totCEFormatted": "2.38 M",
                        "expNot": 1.4286599230399528,
                        "expNotFormatted": "1.43",
                        "peakLiqExp": -5.4614896E7,
                        "peakLiqExpFormatted": "-54.61 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "SIAM",
                        "payNotional": 1.690437037E9,
                        "payNotionalFormatted": "1,690.44 M",
                        "netMTM": -1.0150388E7,
                        "netMTMFormatted": "-10.15 M",
                        "w2Var": 1.7551305E7,
                        "w2VarFormatted": "17.55 M",
                        "peakCE": 2.0272267E8,
                        "peakCEFormatted": "202.72 M",
                        "threshold": 0,
                        "totCE": 1.7551305E7,
                        "totCEFormatted": "17.55 M",
                        "expNot": 1.038270258864424,
                        "expNotFormatted": "1.04",
                        "peakLiqExp": -1.7066059E8,
                        "peakLiqExpFormatted": "-170.66 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "Standard Chartered",
                        "payNotional": 1.582878907E9,
                        "payNotionalFormatted": "1,582.88 M",
                        "netMTM": -2.1206518E7,
                        "netMTMFormatted": "-21.21 M",
                        "w2Var": 2.2000876E7,
                        "w2VarFormatted": "22.00 M",
                        "peakCE": 2.4574805E8,
                        "peakCEFormatted": "245.75 M",
                        "threshold": 0,
                        "totCE": 2.2000876E7,
                        "totCEFormatted": "22.00 M",
                        "expNot": 1.3899279283276216,
                        "expNotFormatted": "1.39",
                        "peakLiqExp": -1.5611194E8,
                        "peakLiqExpFormatted": "-156.11 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "TMB",
                        "payNotional": 1.34603353E8,
                        "payNotionalFormatted": "134.60 M",
                        "netMTM": 5672221.0,
                        "netMTMFormatted": "5.67 M",
                        "w2Var": 1486793.0,
                        "w2VarFormatted": "1.49 M",
                        "peakCE": 1.0116676E7,
                        "peakCEFormatted": "10.12 M",
                        "threshold": 0,
                        "totCE": 1986793.0,
                        "totCEFormatted": "1.99 M",
                        "expNot": 1.4760352960895409,
                        "expNotFormatted": "1.48",
                        "peakLiqExp": -9663572.0,
                        "peakLiqExpFormatted": "-9.66 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIA Thailand",
                            "name": "Thailand",
                            "code": "THAI",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIA Thailand",
                        "counterParty": "UOB",
                        "payNotional": 7700000.0,
                        "payNotionalFormatted": "7.70 M",
                        "netMTM": 30640.0,
                        "netMTMFormatted": "30.64 k",
                        "w2Var": 217278.0,
                        "w2VarFormatted": "217.28 k",
                        "peakCE": 4510731.0,
                        "peakCEFormatted": "4.51 M",
                        "threshold": 0,
                        "totCE": 717278.0,
                        "totCEFormatted": "717.28 k",
                        "expNot": 9.315298701298701,
                        "expNotFormatted": "9.32",
                        "peakLiqExp": -2060931.0,
                        "peakLiqExpFormatted": "-2.06 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H CM CCP)",
                            "name": "HK (Par H CM CCP)",
                            "code": "HK (Par H CM CCP)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H CM CCP)",
                        "counterParty": "BNP Paribas",
                        "payNotional": 1.54E7,
                        "payNotionalFormatted": "15.40 M",
                        "netMTM": -109026.0,
                        "netMTMFormatted": "-109.03 k",
                        "w2Var": 536001.0,
                        "w2VarFormatted": "536.00 k",
                        "peakCE": 7208018.0,
                        "peakCEFormatted": "7.21 M",
                        "threshold": 0,
                        "totCE": 536001.0,
                        "totCEFormatted": "536.00 k",
                        "expNot": 3.480525974025974,
                        "expNotFormatted": "3.48",
                        "peakLiqExp": -1.1118862E7,
                        "peakLiqExpFormatted": "-11.12 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H CM)",
                            "name": "HK (Par H CM)",
                            "code": "HK (Par H CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H CM)",
                        "counterParty": "BNP Paribas",
                        "payNotional": 4.49161638E8,
                        "payNotionalFormatted": "449.16 M",
                        "netMTM": -7.2480056E7,
                        "netMTMFormatted": "-72.48 M",
                        "w2Var": 1.4056564E7,
                        "w2VarFormatted": "14.06 M",
                        "peakCE": 6.37436E7,
                        "peakCEFormatted": "63.74 M",
                        "threshold": 0,
                        "totCE": 1.4056564E7,
                        "totCEFormatted": "14.06 M",
                        "expNot": 3.129511251804634,
                        "expNotFormatted": "3.13",
                        "peakLiqExp": -1.5522186E8,
                        "peakLiqExpFormatted": "-155.22 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H CM)",
                            "name": "HK (Par H CM)",
                            "code": "HK (Par H CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H CM)",
                        "counterParty": "Goldman Sachs",
                        "payNotional": 1.133621541E9,
                        "payNotionalFormatted": "1,133.62 M",
                        "netMTM": -1.99624E8,
                        "netMTMFormatted": "-199.62 M",
                        "w2Var": 3.586627E7,
                        "w2VarFormatted": "35.87 M",
                        "peakCE": 4.6265696E7,
                        "peakCEFormatted": "46.27 M",
                        "threshold": 0,
                        "totCE": 3.586627E7,
                        "totCEFormatted": "35.87 M",
                        "expNot": 3.1638663083590783,
                        "expNotFormatted": "3.16",
                        "peakLiqExp": -3.3171978E8,
                        "peakLiqExpFormatted": "-331.72 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H CM)",
                            "name": "HK (Par H CM)",
                            "code": "HK (Par H CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H CM)",
                        "counterParty": "HSBC",
                        "payNotional": 4.43134527E8,
                        "payNotionalFormatted": "443.13 M",
                        "netMTM": -8.315456E7,
                        "netMTMFormatted": "-83.15 M",
                        "w2Var": 1.3826424E7,
                        "w2VarFormatted": "13.83 M",
                        "peakCE": 1.4339601E7,
                        "peakCEFormatted": "14.34 M",
                        "threshold": 0,
                        "totCE": 1.3826424E7,
                        "totCEFormatted": "13.83 M",
                        "expNot": 3.120141437320229,
                        "expNotFormatted": "3.12",
                        "peakLiqExp": -1.3274157E8,
                        "peakLiqExpFormatted": "-132.74 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H CM)",
                            "name": "HK (Par H CM)",
                            "code": "HK (Par H CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H CM)",
                        "counterParty": "JP Morgan",
                        "payNotional": 2.39674927E8,
                        "payNotionalFormatted": "239.67 M",
                        "netMTM": -2.1772764E7,
                        "netMTMFormatted": "-21.77 M",
                        "w2Var": 7707131.0,
                        "w2VarFormatted": "7.71 M",
                        "peakCE": 6.611267E7,
                        "peakCEFormatted": "66.11 M",
                        "threshold": 0,
                        "totCE": 7707131.0,
                        "totCEFormatted": "7.71 M",
                        "expNot": 3.215660101150255,
                        "expNotFormatted": "3.22",
                        "peakLiqExp": -6.6950296E7,
                        "peakLiqExpFormatted": "-66.95 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par H CM)",
                            "name": "HK (Par H CM)",
                            "code": "HK (Par H CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par H CM)",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 1.36901099E9,
                        "payNotionalFormatted": "1,369.01 M",
                        "netMTM": -2.186314E8,
                        "netMTMFormatted": "-218.63 M",
                        "w2Var": 4.230534E7,
                        "w2VarFormatted": "42.31 M",
                        "peakCE": 1.9858538E8,
                        "peakCEFormatted": "198.59 M",
                        "threshold": 0,
                        "totCE": 4.230534E7,
                        "totCEFormatted": "42.31 M",
                        "expNot": 3.0902118616301246,
                        "expNotFormatted": "3.09",
                        "peakLiqExp": -4.0535363E8,
                        "peakLiqExpFormatted": "-405.35 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par L CM)",
                            "name": "HK (Par L CM)",
                            "code": "HK (Par L CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par L CM)",
                        "counterParty": "JP Morgan",
                        "payNotional": 3.7265676E7,
                        "payNotionalFormatted": "37.27 M",
                        "netMTM": 705353.0,
                        "netMTMFormatted": "705.35 k",
                        "w2Var": 1244144.0,
                        "w2VarFormatted": "1.24 M",
                        "peakCE": 2.332816E7,
                        "peakCEFormatted": "23.33 M",
                        "threshold": 0,
                        "totCE": 1744144.0,
                        "totCEFormatted": "1.74 M",
                        "expNot": 4.680296152416503,
                        "expNotFormatted": "4.68",
                        "peakLiqExp": -1.5767217E7,
                        "peakLiqExpFormatted": "-15.77 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par L CM)",
                            "name": "HK (Par L CM)",
                            "code": "HK (Par L CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par L CM)",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 7.4313692E7,
                        "payNotionalFormatted": "74.31 M",
                        "netMTM": 1649146.0,
                        "netMTMFormatted": "1.65 M",
                        "w2Var": 2516565.0,
                        "w2VarFormatted": "2.52 M",
                        "peakCE": 4.722076E7,
                        "peakCEFormatted": "47.22 M",
                        "threshold": 0,
                        "totCE": 3016565.0,
                        "totCEFormatted": "3.02 M",
                        "expNot": 4.059231776561444,
                        "expNotFormatted": "4.06",
                        "peakLiqExp": -3.1637572E7,
                        "peakLiqExpFormatted": "-31.64 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par L)",
                            "name": "HK (Par L)",
                            "code": "HK (Par L)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par L)",
                        "counterParty": "Citigroup",
                        "payNotional": 1.0E8,
                        "payNotionalFormatted": "100.00 M",
                        "netMTM": -314771.0,
                        "netMTMFormatted": "-314.77 k",
                        "w2Var": 910494.0,
                        "w2VarFormatted": "910.49 k",
                        "peakCE": 5426486.0,
                        "peakCEFormatted": "5.43 M",
                        "threshold": 0,
                        "totCE": 910494.0,
                        "totCEFormatted": "910.49 k",
                        "expNot": 0.910494,
                        "expNotFormatted": "0.91",
                        "peakLiqExp": -7810554.0,
                        "peakLiqExpFormatted": "-7.81 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par L)",
                            "name": "HK (Par L)",
                            "code": "HK (Par L)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par L)",
                        "counterParty": "Standard Chartered",
                        "payNotional": 1.0E8,
                        "payNotionalFormatted": "100.00 M",
                        "netMTM": -344060.0,
                        "netMTMFormatted": "-344.06 k",
                        "w2Var": 981120.0,
                        "w2VarFormatted": "981.12 k",
                        "peakCE": 7030415.0,
                        "peakCEFormatted": "7.03 M",
                        "threshold": 0,
                        "totCE": 981120.0,
                        "totCEFormatted": "981.12 k",
                        "expNot": 0.9811200000000001,
                        "expNotFormatted": "0.98",
                        "peakLiqExp": -9690339.0,
                        "peakLiqExpFormatted": "-9.69 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM CCP)",
                            "name": "HK (Par M CM CCP)",
                            "code": "HK (Par M CM CCP)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM CCP)",
                        "counterParty": "BNP Paribas",
                        "payNotional": 2.42E7,
                        "payNotionalFormatted": "24.20 M",
                        "netMTM": -171327.0,
                        "netMTMFormatted": "-171.33 k",
                        "w2Var": 842288.0,
                        "w2VarFormatted": "842.29 k",
                        "peakCE": 1.1326886E7,
                        "peakCEFormatted": "11.33 M",
                        "threshold": 0,
                        "totCE": 842288.0,
                        "totCEFormatted": "842.29 k",
                        "expNot": 3.480528925619835,
                        "expNotFormatted": "3.48",
                        "peakLiqExp": -1.7472498E7,
                        "peakLiqExpFormatted": "-17.47 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "BNP Paribas",
                        "payNotional": 6.41127941E8,
                        "payNotionalFormatted": "641.13 M",
                        "netMTM": -3.1576748E7,
                        "netMTMFormatted": "-31.58 M",
                        "w2Var": 2.1495085E7,
                        "w2VarFormatted": "21.50 M",
                        "peakCE": 2.6781376E8,
                        "peakCEFormatted": "267.81 M",
                        "threshold": 0,
                        "totCE": 2.1495085E7,
                        "totCEFormatted": "21.50 M",
                        "expNot": 3.352698209732213,
                        "expNotFormatted": "3.35",
                        "peakLiqExp": -2.0049307E8,
                        "peakLiqExpFormatted": "-200.49 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "CACIB",
                        "payNotional": 5.54790668E8,
                        "payNotionalFormatted": "554.79 M",
                        "netMTM": 6829569.0,
                        "netMTMFormatted": "6.83 M",
                        "w2Var": 1.9172115E7,
                        "w2VarFormatted": "19.17 M",
                        "peakCE": 3.289388E8,
                        "peakCEFormatted": "328.94 M",
                        "threshold": 0,
                        "totCE": 1.9672115E7,
                        "totCEFormatted": "19.67 M",
                        "expNot": 3.5458626351660265,
                        "expNotFormatted": "3.55",
                        "peakLiqExp": -2.0769795E8,
                        "peakLiqExpFormatted": "-207.70 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "Goldman Sachs",
                        "payNotional": 7.2405667E8,
                        "payNotionalFormatted": "724.06 M",
                        "netMTM": -7.029627E7,
                        "netMTMFormatted": "-70.30 M",
                        "w2Var": 2.358453E7,
                        "w2VarFormatted": "23.58 M",
                        "peakCE": 2.0125557E8,
                        "peakCEFormatted": "201.26 M",
                        "threshold": 0,
                        "totCE": 2.358453E7,
                        "totCEFormatted": "23.58 M",
                        "expNot": 3.2572768095624336,
                        "expNotFormatted": "3.26",
                        "peakLiqExp": -1.7098294E8,
                        "peakLiqExpFormatted": "-170.98 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "HSBC",
                        "payNotional": 3.58178572E8,
                        "payNotionalFormatted": "358.18 M",
                        "netMTM": -3.9030012E7,
                        "netMTMFormatted": "-39.03 M",
                        "w2Var": 1.1603688E7,
                        "w2VarFormatted": "11.60 M",
                        "peakCE": 8.626487E7,
                        "peakCEFormatted": "86.26 M",
                        "threshold": 0,
                        "totCE": 1.1603688E7,
                        "totCEFormatted": "11.60 M",
                        "expNot": 3.2396376855285474,
                        "expNotFormatted": "3.24",
                        "peakLiqExp": -8.845904E7,
                        "peakLiqExpFormatted": "-88.46 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "JP Morgan",
                        "payNotional": 6.11159818E8,
                        "payNotionalFormatted": "611.16 M",
                        "netMTM": -4.30345E7,
                        "netMTMFormatted": "-43.03 M",
                        "w2Var": 1.9937968E7,
                        "w2VarFormatted": "19.94 M",
                        "peakCE": 2.6587598E8,
                        "peakCEFormatted": "265.88 M",
                        "threshold": 0,
                        "totCE": 1.9937968E7,
                        "totCEFormatted": "19.94 M",
                        "expNot": 3.262316568069925,
                        "expNotFormatted": "3.26",
                        "peakLiqExp": -2.6130285E8,
                        "peakLiqExpFormatted": "-261.30 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 4.135716834E9,
                        "payNotionalFormatted": "4,135.72 M",
                        "netMTM": -4.635694E8,
                        "netMTMFormatted": "-463.57 M",
                        "w2Var": 1.307508E8,
                        "w2VarFormatted": "130.75 M",
                        "peakCE": 1.2314865E9,
                        "peakCEFormatted": "1,231.49 M",
                        "threshold": 0,
                        "totCE": 1.307508E8,
                        "totCEFormatted": "130.75 M",
                        "expNot": 3.161502715202576,
                        "expNotFormatted": "3.16",
                        "peakLiqExp": -1.3258728E9,
                        "peakLiqExpFormatted": "-1,325.87 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par M CM)",
                            "name": "HK (Par M CM)",
                            "code": "HK (Par M CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par M CM)",
                        "counterParty": "Societe Generale",
                        "payNotional": 2.62464761E8,
                        "payNotionalFormatted": "262.46 M",
                        "netMTM": -243471.0,
                        "netMTMFormatted": "-243.47 k",
                        "w2Var": 9047903.0,
                        "w2VarFormatted": "9.05 M",
                        "peakCE": 1.5165515E8,
                        "peakCEFormatted": "151.66 M",
                        "threshold": 0,
                        "totCE": 9047903.0,
                        "totCEFormatted": "9.05 M",
                        "expNot": 3.4472829668741705,
                        "expNotFormatted": "3.45",
                        "peakLiqExp": -1.0193317E8,
                        "peakLiqExpFormatted": "-101.93 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM CCP)",
                            "name": "HK (Par X CM CCP)",
                            "code": "HK (Par X CM CCP)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM CCP)",
                        "counterParty": "BNP Paribas",
                        "payNotional": 5.104E8,
                        "payNotionalFormatted": "510.40 M",
                        "netMTM": 6072413.0,
                        "netMTMFormatted": "6.07 M",
                        "w2Var": 1.5505309E7,
                        "w2VarFormatted": "15.51 M",
                        "peakCE": 2.9034832E8,
                        "peakCEFormatted": "290.35 M",
                        "threshold": 0,
                        "totCE": 1.6005309E7,
                        "totCEFormatted": "16.01 M",
                        "expNot": 3.1358364028213166,
                        "expNotFormatted": "3.14",
                        "peakLiqExp": -3.4800954E8,
                        "peakLiqExpFormatted": "-348.01 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM)",
                        "counterParty": "BNP Paribas",
                        "payNotional": 2.5485664E8,
                        "payNotionalFormatted": "254.86 M",
                        "netMTM": -3.376949E7,
                        "netMTMFormatted": "-33.77 M",
                        "w2Var": 8326206.0,
                        "w2VarFormatted": "8.33 M",
                        "peakCE": 3.471157E7,
                        "peakCEFormatted": "34.71 M",
                        "threshold": 0,
                        "totCE": 8326206.0,
                        "totCEFormatted": "8.33 M",
                        "expNot": 3.2670155268467798,
                        "expNotFormatted": "3.27",
                        "peakLiqExp": -6.933042E7,
                        "peakLiqExpFormatted": "-69.33 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM)",
                        "counterParty": "CACIB",
                        "payNotional": 8.5835075E7,
                        "payNotionalFormatted": "85.84 M",
                        "netMTM": 116341.0,
                        "netMTMFormatted": "116.34 k",
                        "w2Var": 2940417.0,
                        "w2VarFormatted": "2.94 M",
                        "peakCE": 5.3511372E7,
                        "peakCEFormatted": "53.51 M",
                        "threshold": 0,
                        "totCE": 3440417.0,
                        "totCEFormatted": "3.44 M",
                        "expNot": 4.0081714846756995,
                        "expNotFormatted": "4.01",
                        "peakLiqExp": -3.8857296E7,
                        "peakLiqExpFormatted": "-38.86 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM)",
                        "counterParty": "Goldman Sachs",
                        "payNotional": 8.69911405E8,
                        "payNotionalFormatted": "869.91 M",
                        "netMTM": -1.3707819E8,
                        "netMTMFormatted": "-137.08 M",
                        "w2Var": 2.78231E7,
                        "w2VarFormatted": "27.82 M",
                        "peakCE": 5.3537036E7,
                        "peakCEFormatted": "53.54 M",
                        "threshold": 0,
                        "totCE": 2.78231E7,
                        "totCEFormatted": "27.82 M",
                        "expNot": 3.1983831732841805,
                        "expNotFormatted": "3.20",
                        "peakLiqExp": -2.0091472E8,
                        "peakLiqExpFormatted": "-200.91 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM)",
                        "counterParty": "HSBC",
                        "payNotional": 4.62637845E8,
                        "payNotionalFormatted": "462.64 M",
                        "netMTM": -8.01572E7,
                        "netMTMFormatted": "-80.16 M",
                        "w2Var": 1.456007E7,
                        "w2VarFormatted": "14.56 M",
                        "peakCE": 2.5287168E7,
                        "peakCEFormatted": "25.29 M",
                        "threshold": 0,
                        "totCE": 1.456007E7,
                        "totCEFormatted": "14.56 M",
                        "expNot": 3.1471852459454546,
                        "expNotFormatted": "3.15",
                        "peakLiqExp": -1.17511736E8,
                        "peakLiqExpFormatted": "-117.51 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM)",
                        "counterParty": "JP Morgan",
                        "payNotional": 2.33715136E8,
                        "payNotionalFormatted": "233.72 M",
                        "netMTM": -4.002093E7,
                        "netMTMFormatted": "-40.02 M",
                        "w2Var": 7301362.0,
                        "w2VarFormatted": "7.30 M",
                        "peakCE": 2.5090352E7,
                        "peakCEFormatted": "25.09 M",
                        "threshold": 0,
                        "totCE": 7301362.0,
                        "totCEFormatted": "7.30 M",
                        "expNot": 3.1240432797643023,
                        "expNotFormatted": "3.12",
                        "peakLiqExp": -4.7301676E7,
                        "peakLiqExpFormatted": "-47.30 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X CM)",
                            "name": "HK (Par X CM)",
                            "code": "HK (Par X CM)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X CM)",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 8.45054271E8,
                        "payNotionalFormatted": "845.05 M",
                        "netMTM": -6.6321876E7,
                        "netMTMFormatted": "-66.32 M",
                        "w2Var": 2.7580688E7,
                        "w2VarFormatted": "27.58 M",
                        "peakCE": 2.5185582E8,
                        "peakCEFormatted": "251.86 M",
                        "threshold": 0,
                        "totCE": 2.7580688E7,
                        "totCEFormatted": "27.58 M",
                        "expNot": 3.2637771260965556,
                        "expNotFormatted": "3.26",
                        "peakLiqExp": -1.8830403E8,
                        "peakLiqExpFormatted": "-188.30 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - HK (Par X)",
                            "name": "HK (Par X)",
                            "code": "HK (Par X)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - HK (Par X)",
                        "counterParty": "HSBC",
                        "payNotional": 1.0E8,
                        "payNotionalFormatted": "100.00 M",
                        "netMTM": -381572.0,
                        "netMTMFormatted": "-381.57 k",
                        "w2Var": 909320.0,
                        "w2VarFormatted": "909.32 k",
                        "peakCE": 5438052.0,
                        "peakCEFormatted": "5.44 M",
                        "threshold": 0,
                        "totCE": 909320.0,
                        "totCEFormatted": "909.32 k",
                        "expNot": 0.9093199999999999,
                        "expNotFormatted": "0.91",
                        "peakLiqExp": -7815070.0,
                        "peakLiqExpFormatted": "-7.82 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (AL)",
                            "name": "Korea (AL)",
                            "code": "KOREA (AL)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (AL)",
                        "counterParty": "Citigroup",
                        "payNotional": 4.6E7,
                        "payNotionalFormatted": "46.00 M",
                        "netMTM": -1944643.0,
                        "netMTMFormatted": "-1.94 M",
                        "w2Var": 989581.0,
                        "w2VarFormatted": "989.58 k",
                        "peakCE": 4653699.0,
                        "peakCEFormatted": "4.65 M",
                        "threshold": 0,
                        "totCE": 989581.0,
                        "totCEFormatted": "989.58 k",
                        "expNot": 2.1512630434782607,
                        "expNotFormatted": "2.15",
                        "peakLiqExp": -5539285.0,
                        "peakLiqExpFormatted": "-5.54 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (AL)",
                            "name": "Korea (AL)",
                            "code": "KOREA (AL)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (AL)",
                        "counterParty": "HSBC",
                        "payNotional": 7.94E7,
                        "payNotionalFormatted": "79.40 M",
                        "netMTM": -4010248.0,
                        "netMTMFormatted": "-4.01 M",
                        "w2Var": 2099985.0,
                        "w2VarFormatted": "2.10 M",
                        "peakCE": 1.2642187E7,
                        "peakCEFormatted": "12.64 M",
                        "threshold": 0,
                        "totCE": 2099985.0,
                        "totCEFormatted": "2.10 M",
                        "expNot": 2.6448173803526447,
                        "expNotFormatted": "2.64",
                        "peakLiqExp": -1.281937E7,
                        "peakLiqExpFormatted": "-12.82 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (AL)",
                            "name": "Korea (AL)",
                            "code": "KOREA (AL)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (AL)",
                        "counterParty": "Standard Chartered",
                        "payNotional": 2.037E8,
                        "payNotionalFormatted": "203.70 M",
                        "netMTM": -1.0716904E7,
                        "netMTMFormatted": "-10.72 M",
                        "w2Var": 9868180.0,
                        "w2VarFormatted": "9.87 M",
                        "peakCE": 4.580286E7,
                        "peakCEFormatted": "45.80 M",
                        "threshold": 0,
                        "totCE": 9868180.0,
                        "totCEFormatted": "9.87 M",
                        "expNot": 4.84446735395189,
                        "expNotFormatted": "4.84",
                        "peakLiqExp": -5.094665E7,
                        "peakLiqExpFormatted": "-50.95 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (GA)",
                            "name": "Korea (GA)",
                            "code": "KOREA (GA)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (GA)",
                        "counterParty": "Citigroup",
                        "payNotional": 3.145E8,
                        "payNotionalFormatted": "314.50 M",
                        "netMTM": -9152976.0,
                        "netMTMFormatted": "-9.15 M",
                        "w2Var": 1.7623952E7,
                        "w2VarFormatted": "17.62 M",
                        "peakCE": 9.190188E7,
                        "peakCEFormatted": "91.90 M",
                        "threshold": 0,
                        "totCE": 1.7623952E7,
                        "totCEFormatted": "17.62 M",
                        "expNot": 5.603800317965024,
                        "expNotFormatted": "5.60",
                        "peakLiqExp": -8.126309E7,
                        "peakLiqExpFormatted": "-81.26 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (GA)",
                            "name": "Korea (GA)",
                            "code": "KOREA (GA)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (GA)",
                        "counterParty": "HSBC",
                        "payNotional": 9.672E7,
                        "payNotionalFormatted": "96.72 M",
                        "netMTM": -724207.0,
                        "netMTMFormatted": "-724.21 k",
                        "w2Var": 4882563.0,
                        "w2VarFormatted": "4.88 M",
                        "peakCE": 2.7749336E7,
                        "peakCEFormatted": "27.75 M",
                        "threshold": 0,
                        "totCE": 4882563.0,
                        "totCEFormatted": "4.88 M",
                        "expNot": 5.048142059553349,
                        "expNotFormatted": "5.05",
                        "peakLiqExp": -2.1056676E7,
                        "peakLiqExpFormatted": "-21.06 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "AIAI - KOREA (GA)",
                            "name": "Korea (GA)",
                            "code": "KOREA (GA)",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "AIAI - KOREA (GA)",
                        "counterParty": "Standard Chartered",
                        "payNotional": 3.87036E8,
                        "payNotionalFormatted": "387.04 M",
                        "netMTM": -1.8670446E7,
                        "netMTMFormatted": "-18.67 M",
                        "w2Var": 1.9993055E7,
                        "w2VarFormatted": "19.99 M",
                        "peakCE": 9.708314E7,
                        "peakCEFormatted": "97.08 M",
                        "threshold": 0,
                        "totCE": 1.9993055E7,
                        "totCEFormatted": "19.99 M",
                        "expNot": 5.165683553984643,
                        "expNotFormatted": "5.17",
                        "peakLiqExp": -9.8843784E7,
                        "peakLiqExpFormatted": "-98.84 M",
                        "thresholdFormatted": "0.0"
                    }
                ],
                "total": {
                    "legalEntity": null,
                    "fund": null,
                    "counterParty": null,
                    "payNotional": 3.1344722534E10,
                    "payNotionalFormatted": "31,344.72 M",
                    "netMTM": -1.602609121E9,
                    "netMTMFormatted": "-1,602.61 M",
                    "w2Var": 7.73279112E8,
                    "w2VarFormatted": "773.28 M",
                    "peakCE": 6.581966699E9,
                    "peakCEFormatted": "6,581.97 M",
                    "threshold": 3000000,
                    "totCE": 8.35265659E8,
                    "totCEFormatted": "835.27 M",
                    "expNot": 258.9105862185473,
                    "expNotFormatted": "258.91",
                    "peakLiqExp": -6.705534284E9,
                    "peakLiqExpFormatted": "-6,705.53 M",
                    "thresholdFormatted": "3.00 M"
                }
            },
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "query": null,
            "simuProductNotional": null
            };
    }

    private getFakeDerivativeExposureHide(){
        return {
            "aampProductInfoList": null,
            "aampProductInfoSimuList": null,
            "derivativeHoldings": null,
            "aampQuotas": null,
            "entityCounterPartyCcrAndEces": null,
            "counterPartyDerivativeVsCollaterals": null,
            "wccrPeriods": null,
            "instrumentGridItems": null,
            "countryLevelTails": null,
            "rolloverToCashSetting": null,
            "entityTrades": null,
            "derivativeExposureResponse": {
                "derivativeExposures": [
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "ANZ",
                        "payNotional": 1.11903542E8,
                        "payNotionalFormatted": "111.90 M",
                        "netMTM": 6170315.0,
                        "netMTMFormatted": "6.17 M",
                        "w2Var": 2994010.0,
                        "w2VarFormatted": "2.99 M",
                        "peakCE": 3.1981715E7,
                        "peakCEFormatted": "31.98 M",
                        "threshold": 0,
                        "totCE": 3494010.0,
                        "totCEFormatted": "3.49 M",
                        "expNot": 3.1223408460118267,
                        "expNotFormatted": "3.12",
                        "peakLiqExp": -3.3170763E7,
                        "peakLiqExpFormatted": "-33.17 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Ayudhya Public",
                        "payNotional": 6.35719645E8,
                        "payNotionalFormatted": "635.72 M",
                        "netMTM": 2.3083378E7,
                        "netMTMFormatted": "23.08 M",
                        "w2Var": 8229104.0,
                        "w2VarFormatted": "8.23 M",
                        "peakCE": 9.642606E7,
                        "peakCEFormatted": "96.43 M",
                        "threshold": 0,
                        "totCE": 8729104.0,
                        "totCEFormatted": "8.73 M",
                        "expNot": 1.3731059074004233,
                        "expNotFormatted": "1.37",
                        "peakLiqExp": -4.7139748E7,
                        "peakLiqExpFormatted": "-47.14 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "BNP Paribas",
                        "payNotional": 3.013158295E9,
                        "payNotionalFormatted": "3,013.16 M",
                        "netMTM": -1.40292472E8,
                        "netMTMFormatted": "-140.29 M",
                        "w2Var": 8.4293087E7,
                        "w2VarFormatted": "84.29 M",
                        "peakCE": 1.031893214E9,
                        "peakCEFormatted": "1,031.89 M",
                        "threshold": 0,
                        "totCE": 8.4793087E7,
                        "totCEFormatted": "84.79 M",
                        "expNot": 2.814093343210832,
                        "expNotFormatted": "2.81",
                        "peakLiqExp": -1.01601054E9,
                        "peakLiqExpFormatted": "-1,016.01 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Bangkok Bank",
                        "payNotional": 4.45768987E8,
                        "payNotionalFormatted": "445.77 M",
                        "netMTM": -2.9078664E7,
                        "netMTMFormatted": "-29.08 M",
                        "w2Var": 7747426.0,
                        "w2VarFormatted": "7.75 M",
                        "peakCE": 9.78431E7,
                        "peakCEFormatted": "97.84 M",
                        "threshold": 0,
                        "totCE": 7747426.0,
                        "totCEFormatted": "7.75 M",
                        "expNot": 1.7379912524062604,
                        "expNotFormatted": "1.74",
                        "peakLiqExp": -2.5161848E8,
                        "peakLiqExpFormatted": "-251.62 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "CACIB",
                        "payNotional": 7.12618254E8,
                        "payNotionalFormatted": "712.62 M",
                        "netMTM": 5388188.0,
                        "netMTMFormatted": "5.39 M",
                        "w2Var": 2.4907522E7,
                        "w2VarFormatted": "24.91 M",
                        "peakCE": 3.92004085E8,
                        "peakCEFormatted": "392.00 M",
                        "threshold": 0,
                        "totCE": 2.5907522E7,
                        "totCEFormatted": "25.91 M",
                        "expNot": 3.635540046101598,
                        "expNotFormatted": "3.64",
                        "peakLiqExp": -2.64810304E8,
                        "peakLiqExpFormatted": "-264.81 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "CIMB",
                        "payNotional": 7.21641747E8,
                        "payNotionalFormatted": "721.64 M",
                        "netMTM": -1.1542441E7,
                        "netMTMFormatted": "-11.54 M",
                        "w2Var": 1.2219978E7,
                        "w2VarFormatted": "12.22 M",
                        "peakCE": 1.25352734E8,
                        "peakCEFormatted": "125.35 M",
                        "threshold": 0,
                        "totCE": 1.2219978E7,
                        "totCEFormatted": "12.22 M",
                        "expNot": 1.6933579647797177,
                        "expNotFormatted": "1.69",
                        "peakLiqExp": -1.17760895E8,
                        "peakLiqExpFormatted": "-117.76 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "China Trust",
                        "payNotional": 1.71496117E8,
                        "payNotionalFormatted": "171.50 M",
                        "netMTM": 1.38326E7,
                        "netMTMFormatted": "13.83 M",
                        "w2Var": 2040346.0,
                        "w2VarFormatted": "2.04 M",
                        "peakCE": 1.8113216E7,
                        "peakCEFormatted": "18.11 M",
                        "threshold": 0,
                        "totCE": 1.5872946E7,
                        "totCEFormatted": "15.87 M",
                        "expNot": 9.255571658220111,
                        "expNotFormatted": "9.26",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Citigroup",
                        "payNotional": 1.944762481E9,
                        "payNotionalFormatted": "1,944.76 M",
                        "netMTM": 2.8222224E7,
                        "netMTMFormatted": "28.22 M",
                        "w2Var": 5.2972766E7,
                        "w2VarFormatted": "52.97 M",
                        "peakCE": 4.78332666E8,
                        "peakCEFormatted": "478.33 M",
                        "threshold": 3000000,
                        "totCE": 6.5221821E7,
                        "totCEFormatted": "65.22 M",
                        "expNot": 3.3537165405650375,
                        "expNotFormatted": "3.35",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "3.00 M"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "DBS",
                        "payNotional": 9.33185E8,
                        "payNotionalFormatted": "933.18 M",
                        "netMTM": 2039188.0,
                        "netMTMFormatted": "2.04 M",
                        "w2Var": 2.5923379E7,
                        "w2VarFormatted": "25.92 M",
                        "peakCE": 1.78503608E8,
                        "peakCEFormatted": "178.50 M",
                        "threshold": 0,
                        "totCE": 2.6423379E7,
                        "totCEFormatted": "26.42 M",
                        "expNot": 2.831526331863457,
                        "expNotFormatted": "2.83",
                        "peakLiqExp": -1.17826184E8,
                        "peakLiqExpFormatted": "-117.83 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Deutsche",
                        "payNotional": 3.355E7,
                        "payNotionalFormatted": "33.55 M",
                        "netMTM": -1162790.0,
                        "netMTMFormatted": "-1.16 M",
                        "w2Var": 1340425.0,
                        "w2VarFormatted": "1.34 M",
                        "peakCE": 2.6877608E7,
                        "peakCEFormatted": "26.88 M",
                        "threshold": 0,
                        "totCE": 1340425.0,
                        "totCEFormatted": "1.34 M",
                        "expNot": 3.9953055141579727,
                        "expNotFormatted": "4.00",
                        "peakLiqExp": -1.1151376E7,
                        "peakLiqExpFormatted": "-11.15 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "First Commercial",
                        "payNotional": 1.10435315E8,
                        "payNotionalFormatted": "110.44 M",
                        "netMTM": 6899580.0,
                        "netMTMFormatted": "6.90 M",
                        "w2Var": 488918.0,
                        "w2VarFormatted": "488.92 k",
                        "peakCE": 8148205.0,
                        "peakCEFormatted": "8.15 M",
                        "threshold": 0,
                        "totCE": 7388498.0,
                        "totCEFormatted": "7.39 M",
                        "expNot": 6.69033995149106,
                        "expNotFormatted": "6.69",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Goldman Sachs",
                        "payNotional": 2.896105809E9,
                        "payNotionalFormatted": "2,896.11 M",
                        "netMTM": -4.06247784E8,
                        "netMTMFormatted": "-406.25 M",
                        "w2Var": 9.1519638E7,
                        "w2VarFormatted": "91.52 M",
                        "peakCE": 3.0981089E8,
                        "peakCEFormatted": "309.81 M",
                        "threshold": 0,
                        "totCE": 9.2019638E7,
                        "totCEFormatted": "92.02 M",
                        "expNot": 3.1773575990917813,
                        "expNotFormatted": "3.18",
                        "peakLiqExp": -7.11570652E8,
                        "peakLiqExpFormatted": "-711.57 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "HSBC",
                        "payNotional": 3.997439106E9,
                        "payNotionalFormatted": "3,997.44 M",
                        "netMTM": -2.09539207E8,
                        "netMTMFormatted": "-209.54 M",
                        "w2Var": 8.4177478E7,
                        "w2VarFormatted": "84.18 M",
                        "peakCE": 4.66506717E8,
                        "peakCEFormatted": "466.51 M",
                        "threshold": 0,
                        "totCE": 8.5177478E7,
                        "totCEFormatted": "85.18 M",
                        "expNot": 2.130801138962991,
                        "expNotFormatted": "2.13",
                        "peakLiqExp": -5.79321159E8,
                        "peakLiqExpFormatted": "-579.32 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "ING",
                        "payNotional": 1.69E7,
                        "payNotionalFormatted": "16.90 M",
                        "netMTM": 683822.0,
                        "netMTMFormatted": "683.82 k",
                        "w2Var": 689683.0,
                        "w2VarFormatted": "689.68 k",
                        "peakCE": 5879960.0,
                        "peakCEFormatted": "5.88 M",
                        "threshold": 0,
                        "totCE": 1189683.0,
                        "totCEFormatted": "1.19 M",
                        "expNot": 7.039544378698224,
                        "expNotFormatted": "7.04",
                        "peakLiqExp": -3556928.0,
                        "peakLiqExpFormatted": "-3.56 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "JP Morgan",
                        "payNotional": 1.790377795E9,
                        "payNotionalFormatted": "1,790.38 M",
                        "netMTM": -1.02951928E8,
                        "netMTMFormatted": "-102.95 M",
                        "w2Var": 5.4983559E7,
                        "w2VarFormatted": "54.98 M",
                        "peakCE": 5.48131815E8,
                        "peakCEFormatted": "548.13 M",
                        "threshold": 0,
                        "totCE": 5.5983559E7,
                        "totCEFormatted": "55.98 M",
                        "expNot": 3.1269131663912306,
                        "expNotFormatted": "3.13",
                        "peakLiqExp": -4.87445547E8,
                        "peakLiqExpFormatted": "-487.45 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Kasikornbank",
                        "payNotional": 4.38569349E8,
                        "payNotionalFormatted": "438.57 M",
                        "netMTM": -2895495.0,
                        "netMTMFormatted": "-2.90 M",
                        "w2Var": 5060596.0,
                        "w2VarFormatted": "5.06 M",
                        "peakCE": 4.6279736E7,
                        "peakCEFormatted": "46.28 M",
                        "threshold": 0,
                        "totCE": 5060596.0,
                        "totCEFormatted": "5.06 M",
                        "expNot": 1.153887295484482,
                        "expNotFormatted": "1.15",
                        "peakLiqExp": -6.50726E7,
                        "peakLiqExpFormatted": "-65.07 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Metro",
                        "payNotional": 2.6E7,
                        "payNotionalFormatted": "26.00 M",
                        "netMTM": 3960039.0,
                        "netMTMFormatted": "3.96 M",
                        "w2Var": 1170426.0,
                        "w2VarFormatted": "1.17 M",
                        "peakCE": 1.2139546E7,
                        "peakCEFormatted": "12.14 M",
                        "threshold": 0,
                        "totCE": 1670426.0,
                        "totCEFormatted": "1.67 M",
                        "expNot": 6.424715384615384,
                        "expNotFormatted": "6.42",
                        "peakLiqExp": -4175271.0,
                        "peakLiqExpFormatted": "-4.18 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Mizuho Bank",
                        "payNotional": 1.66838515E8,
                        "payNotionalFormatted": "166.84 M",
                        "netMTM": -2103717.0,
                        "netMTMFormatted": "-2.10 M",
                        "w2Var": 2383555.0,
                        "w2VarFormatted": "2.38 M",
                        "peakCE": 2.1041172E7,
                        "peakCEFormatted": "21.04 M",
                        "threshold": 0,
                        "totCE": 2383555.0,
                        "totCEFormatted": "2.38 M",
                        "expNot": 1.4286599230399528,
                        "expNotFormatted": "1.43",
                        "peakLiqExp": -5.4614896E7,
                        "peakLiqExpFormatted": "-54.61 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Morgan Stanley",
                        "payNotional": 6.632129407E9,
                        "payNotionalFormatted": "6,632.13 M",
                        "netMTM": -7.48783868E8,
                        "netMTMFormatted": "-748.78 M",
                        "w2Var": 2.05553347E8,
                        "w2VarFormatted": "205.55 M",
                        "peakCE": 1.733349174E9,
                        "peakCEFormatted": "1,733.35 M",
                        "threshold": 0,
                        "totCE": 2.06053347E8,
                        "totCEFormatted": "206.05 M",
                        "expNot": 3.1068957548162026,
                        "expNotFormatted": "3.11",
                        "peakLiqExp": -1.960429081E9,
                        "peakLiqExpFormatted": "-1,960.43 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "OCBC",
                        "payNotional": 7.7340056E7,
                        "payNotionalFormatted": "77.34 M",
                        "netMTM": 1183547.0,
                        "netMTMFormatted": "1.18 M",
                        "w2Var": 3437346.0,
                        "w2VarFormatted": "3.44 M",
                        "peakCE": 1.0214986E7,
                        "peakCEFormatted": "10.21 M",
                        "threshold": 0,
                        "totCE": 3937346.0,
                        "totCEFormatted": "3.94 M",
                        "expNot": 5.0909531278332665,
                        "expNotFormatted": "5.09",
                        "peakLiqExp": -1.1373996E7,
                        "peakLiqExpFormatted": "-11.37 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "SIAM",
                        "payNotional": 1.690437037E9,
                        "payNotionalFormatted": "1,690.44 M",
                        "netMTM": -1.0150388E7,
                        "netMTMFormatted": "-10.15 M",
                        "w2Var": 1.7551305E7,
                        "w2VarFormatted": "17.55 M",
                        "peakCE": 2.0272267E8,
                        "peakCEFormatted": "202.72 M",
                        "threshold": 0,
                        "totCE": 1.7551305E7,
                        "totCEFormatted": "17.55 M",
                        "expNot": 1.038270258864424,
                        "expNotFormatted": "1.04",
                        "peakLiqExp": -1.7066059E8,
                        "peakLiqExpFormatted": "-170.66 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Societe Generale",
                        "payNotional": 2.62464761E8,
                        "payNotionalFormatted": "262.46 M",
                        "netMTM": -243471.0,
                        "netMTMFormatted": "-243.47 k",
                        "w2Var": 9047903.0,
                        "w2VarFormatted": "9.05 M",
                        "peakCE": 1.5165515E8,
                        "peakCEFormatted": "151.66 M",
                        "threshold": 0,
                        "totCE": 9047903.0,
                        "totCEFormatted": "9.05 M",
                        "expNot": 3.4472829668741705,
                        "expNotFormatted": "3.45",
                        "peakLiqExp": -1.0193317E8,
                        "peakLiqExpFormatted": "-101.93 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Standard Chartered",
                        "payNotional": 3.953201178E9,
                        "payNotionalFormatted": "3,953.20 M",
                        "netMTM": -6.6709249E7,
                        "netMTMFormatted": "-66.71 M",
                        "w2Var": 6.2720417E7,
                        "w2VarFormatted": "62.72 M",
                        "peakCE": 4.4578945E8,
                        "peakCEFormatted": "445.79 M",
                        "threshold": 0,
                        "totCE": 6.3220417E7,
                        "totCEFormatted": "63.22 M",
                        "expNot": 1.5992208378320987,
                        "expNotFormatted": "1.60",
                        "peakLiqExp": -3.71829526E8,
                        "peakLiqExpFormatted": "-371.83 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "TMB",
                        "payNotional": 1.34603353E8,
                        "payNotionalFormatted": "134.60 M",
                        "netMTM": 5672221.0,
                        "netMTMFormatted": "5.67 M",
                        "w2Var": 1486793.0,
                        "w2VarFormatted": "1.49 M",
                        "peakCE": 1.0116676E7,
                        "peakCEFormatted": "10.12 M",
                        "threshold": 0,
                        "totCE": 1986793.0,
                        "totCEFormatted": "1.99 M",
                        "expNot": 1.4760352960895409,
                        "expNotFormatted": "1.48",
                        "peakLiqExp": -9663572.0,
                        "peakLiqExpFormatted": "-9.66 M",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "Taipei Fubon Commercial",
                        "payNotional": 2.05538686E8,
                        "payNotionalFormatted": "205.54 M",
                        "netMTM": 1.9005312E7,
                        "netMTMFormatted": "19.01 M",
                        "w2Var": 2568348.0,
                        "w2VarFormatted": "2.57 M",
                        "peakCE": 2.7943112E7,
                        "peakCEFormatted": "27.94 M",
                        "threshold": 0,
                        "totCE": 2.157366E7,
                        "totCEFormatted": "21.57 M",
                        "expNot": 10.496155453674545,
                        "expNotFormatted": "10.50",
                        "peakLiqExp": 0.0,
                        "peakLiqExpFormatted": "0.0",
                        "thresholdFormatted": "0.0"
                    },
                    {
                        "legalEntity": {
                            "rowKey": null,
                            "entityId": null,
                            "dataName": "",
                            "name": "",
                            "code": "",
                            "counterParties": null,
                            "ccrOrExpo": 0
                        },
                        "fund": "",
                        "counterParty": "UOB",
                        "payNotional": 2.22538099E8,
                        "payNotionalFormatted": "222.54 M",
                        "netMTM": 1.2951939E7,
                        "netMTMFormatted": "12.95 M",
                        "w2Var": 7771757.0,
                        "w2VarFormatted": "7.77 M",
                        "peakCE": 1.04909434E8,
                        "peakCEFormatted": "104.91 M",
                        "threshold": 0,
                        "totCE": 9271757.0,
                        "totCEFormatted": "9.27 M",
                        "expNot": 4.166368384408639,
                        "expNotFormatted": "4.17",
                        "peakLiqExp": -3.8373084E7,
                        "peakLiqExpFormatted": "-38.37 M",
                        "thresholdFormatted": "0.0"
                    }
                ],
                "total": {
                    "legalEntity": null,
                    "fund": null,
                    "counterParty": null,
                    "payNotional": 3.1344722534E10,
                    "payNotionalFormatted": "31,344.72 M",
                    "netMTM": -1.602609121E9,
                    "netMTMFormatted": "-1,602.61 M",
                    "w2Var": 7.73279112E8,
                    "w2VarFormatted": "773.28 M",
                    "peakCE": 6.581966699E9,
                    "peakCEFormatted": "6,581.97 M",
                    "threshold": 3000000,
                    "totCE": 8.35265659E8,
                    "totCEFormatted": "835.27 M",
                    "expNot": 95.40595032288523,
                    "expNotFormatted": "95.41",
                    "peakLiqExp": -6.429508362E9,
                    "peakLiqExpFormatted": "-6,429.51 M",
                    "thresholdFormatted": "3.00 M"
                }
            },
            "legalEntityAndCounterPartySummaryResponse": null,
            "lowestTenCcrsAndShockedCcrsList": null,
            "lowestWccrList": null,
            "tradeInstruments": null,
            "fxRates": null,
            "notifs": null,
            "latestFiles": null,
            "otcEio": null,
            "otcFxo": null,
            "runIds": null,
            "query": null,
            "simuProductNotional": null
        };
    }

}
